/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** WeightUnit */
export enum WeightUnit {
  Kg = 'kg',
  Stones = 'stones'
}

/** UserRoleEnum */
export enum UserRoleEnum {
  Admin = 'admin',
  Client = 'client',
  Doctor = 'doctor',
  Nutritionist = 'nutritionist',
  SuperAdmin = 'superadmin'
}

/** UserGenderEnum */
export enum UserGenderEnum {
  Male = 'male',
  Female = 'female',
  Other = 'other',
  PreferNotToSay = 'prefer_not_to_say'
}

/** SmokeUseEnum */
export enum SmokeUseEnum {
  Yes = 'Yes',
  No = 'No',
  Occasionally = 'Occasionally'
}

/** ResponseStatusEnum */
export enum ResponseStatusEnum {
  Success = 'success',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Assigned = 'assigned',
  Unassigned = 'unassigned',
  LoggedOut = 'logged_out'
}

/** RaceEnum */
export enum RaceEnum {
  Arab = 'arab',
  Asian = 'asian',
  Black = 'black',
  Latino = 'latino',
  Mixed = 'mixed',
  White = 'white',
  NotSay = 'not_say'
}

/** OverallHealthEnum */
export enum OverallHealthEnum {
  EXCELLENT = 'EXCELLENT',
  GOOD = 'GOOD',
  FAIR = 'FAIR',
  POOR = 'POOR'
}

/** NutritionistLoadStrategy */
export enum NutritionistLoadStrategy {
  WithMembers = 'with_members',
  WithMembersCount = 'with_members_count',
  AllData = 'all_data'
}

/** NotificationType */
export enum NotificationType {
  NewAppointment = 'new_appointment',
  NewTestResult = 'new_test_result',
  NewAdvice = 'new_advice',
  NewHealthSummary = 'new_health_summary',
  AppointmentReminder = 'appointment_reminder',
  NewNote = 'new_note',
  NewRecommendation = 'new_recommendation'
}

/** MemberLoadStrategy */
export enum MemberLoadStrategy {
  WithDoctor = 'with_doctor',
  WithNutritionist = 'with_nutritionist',
  WithDoctorAndNutritionist = 'with_doctor_and_nutritionist',
  WithRecommendations = 'with_recommendations',
  WithSubscription = 'with_subscription',
  AllData = 'all_data'
}

/** MeasurementUnits */
export enum MeasurementUnits {
  MgL = 'mg/L',
  MmolL = 'mmol/L',
  NgML = 'ng/mL',
  PgML = 'pg/mL',
  MgDL = 'mg/dL',
  GDL = 'g/dL',
  CellsΜL = 'cells/μL',
  Value = '%',
  Ratio = 'Ratio',
  GL = 'g/L',
  Pg = 'pg',
  Femtoliters = 'femtoliters',
  X109L = 'x 10^9/L',
  Value10L = '× 10¹²/L',
  IUML = 'IU/mL',
  UML = 'U/mL',
  MIUL = 'mIU/L',
  PmolL = 'pmol/L',
  NmolL = 'nmol/L',
  NA = 'N/A',
  MIUmL = 'mIUmL',
  IUL = 'IU/L',
  KUL = 'kU/L',
  UL = 'U/L',
  UmolL = 'umol/L',
  MmolMol = 'mmol/mol',
  MicromolL = 'micromol/L',
  ValueGL = 'µg/L',
  ValueMolL = 'µmol/L',
  NgL = 'ng/L',
  MmLitre = 'mm/litre',
  MmHour = 'mm/hour',
  MLMin173M2 = 'mL/min/1.73m^2',
  KIU_L = "kIU/L"
}

/** MealType */
export enum MealType {
  Breakfast = 'breakfast',
  Snack = 'snack',
  Lunch = 'lunch',
  Dinner = 'dinner',
  Supper = 'supper'
}

/** AppointmentAssigneeType */
export enum AppointmentAssigneeType {
  DOCTOR = 'DOCTOR',
  NUTRITIONIST = 'NUTRITIONIST',
}

/** LocationType */
export enum LocationType {
  CLINIC = 'CLINIC',
  ONLINE = 'ONLINE',
  TULI = 'TULI',
  HISTORICRESULTS = 'HISTORIC_RESULTS',
  MEMBER_HOME = 'MEMBER_HOME',
  SCAN = 'SCAN',
  DEXA = 'DEXA'
}

/** HeightUnit */
export enum HeightUnit {
  Cm = 'cm',
  Feet = 'feet'
}

/** HealthConcernOption */
export enum HealthConcernOption {
  FamilyHistoryGeneticRisk = 'Family history/Genetic Risk',
  HormonalHealth = 'Hormonal Health',
  FertilityPlanning = 'Fertility Planning',
  DealingWithAnExistingCondition = 'Dealing with an Existing Condition',
  InterestedInLongevityBiohacking = 'Interested in Longevity/Biohacking',
  MetabolicHealth = 'Metabolic Health',
  Other = 'Other',
  None = 'None'
}

/** GoalsOption */
export enum GoalsOption {
  IWantAComprehensiveHealthCheck = 'I want a comprehensive health check',
  ImFeelingUnwellAndWantClarity = 'I’m feeling unwell and want clarity',
  IWantToTakeControlOfMyHealth = 'I want to take control of my health',
  ImInterestedInPreventativeHealthAndLongevity = 'I’m interested in preventative health and longevity',
  MyDoctorCoachRecommendedIt = 'My doctor/coach recommended it',
  Other = 'Other'
}

/** ExerciseFrequencyEnum */
export enum ExerciseFrequencyEnum {
  Never = 'Never',
  Occasionally = 'Occasionally',
  Weekly = 'Weekly',
  Daily = 'Daily'
}

/** DoctorSpecializationEnum */
export enum DoctorSpecializationEnum {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
  Value12 = 12,
  Value13 = 13,
  Value14 = 14,
  Value15 = 15,
  Value16 = 16,
  Value17 = 17,
  Value18 = 18,
  Value19 = 19,
  Value20 = 20,
  Value21 = 21,
  Value22 = 22,
  Value23 = 23,
  Value24 = 24,
  Value25 = 25,
  Value26 = 26,
  Value27 = 27,
  Value28 = 28,
  Value29 = 29,
  Value30 = 30,
  Value31 = 31,
  Value32 = 32,
  Value33 = 33,
  Value34 = 34,
  Value35 = 35,
  Value36 = 36,
  Value37 = 37,
  Value38 = 38,
  Value39 = 39,
  Value40 = 40,
  Value41 = 41,
  Value42 = 42,
  Value43 = 43,
  Value44 = 44,
  Value45 = 45,
  Value46 = 46,
  Value47 = 47,
  Value48 = 48,
  Value49 = 49,
  Value50 = 50,
  Value51 = 51,
  Value52 = 52,
  Value53 = 53,
  Value54 = 54,
  Value55 = 55,
  Value56 = 56,
  Value57 = 57,
  Value58 = 58,
  Value59 = 59
}

/** DoctorLoadStrategy */
export enum DoctorLoadStrategy {
  WithMembers = 'with_members',
  WithMembersCount = 'with_members_count',
  AllData = 'all_data'
}

/** BiomarkerValueMeaning */
export enum BiomarkerValueMeaning {
  POSITIVE_ABNORMAL = 'POSITIVE_ABNORMAL',
  POSITIVE_NORMAL = 'POSITIVE_NORMAL'
}

/** BiomarkerLowHighGood */
export enum BiomarkerLowHighGood {
  NORMAL = 'NORMAL',
  LOW_IS_GOOD = 'LOW_IS_GOOD',
  HIGH_IS_GOOD = 'HIGH_IS_GOOD'
}

/** BiomarkerType */
export enum BiomarkerType {
  RANGES = 'RANGES',
  BINARY = 'BINARY',
  UNITS = 'UNITS'
}

export enum DerivedBiomarkerScaleTarget {
  NUMERATOR = 'NUMERATOR',
  DENOMINATOR = 'DENOMINATOR',
  VALUE = 'VALUE'
}

export enum DerivedBiomarkerFormulaType {
  RATIO = 'RATIO',
  AFFINE = 'AFFINE'
}

export interface DerivedFormulaTerm {
  biomarker_id: number;
  coefficient: number;
}

/** BiomarkerResultType */
export enum BiomarkerResultType {
  UNPROCESSED = 'UNPROCESSED',
  PUBLISHED = 'PUBLISHED'
}

/** BiomarkerResultStatus */
export enum BiomarkerResultStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  AWAITING = 'AWAITING',
  URGENT_RESULT = 'URGENT_RESULT'
}

/** AppointmentStatus */
export enum AppointmentStatus {
  DATE_SCHEDULED = 'DATE_SCHEDULED',
  COMPLETED = 'COMPLETED',
  RUNNING_LATE = 'RUNNING_LATE',
  TO_BE_RESCHEDULED = 'TO_BE_RESCHEDULED',
  CUSTOMER_QUERY = 'CUSTOMER_QUERY',
  DNA = 'DNA'
}

/** AppointmentLoadStrategy */
export enum AppointmentLoadStrategy {
  ALL_DATA = 'ALL_DATA',
  WITH_TEST_RESULTS = 'WITH_TEST_RESULTS',
  WITH_TEST_AND_RESULTS = 'WITH_TEST_AND_RESULTS'
}

/** AppointmentFilter */
export enum AppointmentFilter {
  Upcoming = 'upcoming',
  Past = 'past',
  PastWithToday = 'past_with_today'
}

/** AlcoholFrequencyEnum */
export enum AlcoholFrequencyEnum {
  Never = 'Never',
  Occasionally = 'Occasionally',
  Weekly = 'Weekly',
  Daily = 'Daily'
}

/** WorkingStyleEnum */
export enum WorkingStyleEnum {
  MostlyDeskBased = 'mostly_desk_based',
  MostlyOnTheGoActive = 'mostly_on_the_go_active',
  AMixOfBoth = 'a_mix_of_both',
  ShiftBasedWork = 'shift_based_work',
  Other = 'other'
}

/** HydrationEnum */
export enum HydrationEnum {
  MainlyWaterTap = 'main_water_tap',
  MainlyWaterBottledFiltered = 'main_water_bottled_filtered',
  WaterTeaCoffee = 'water_tea_coffee',
  WaterSoftDrinksEnergyDrinks = 'water_soft_drinks_energy_drinks',
  MinimalWaterIntake = 'minimal_water_intake',
  Other = 'other'
}
export enum HydrationEnum {
  MainlyWaterTap = 'main_water_tap',
  MainlyWaterBottledFiltered = 'main_water_bottled_filtered',
  WaterTeaCoffee = 'water_tea_coffee',
  WaterSoftDrinksEnergyDrinks = 'water_soft_drinks_energy_drinks',
  MinimalWaterIntake = 'minimal_water_intake',
  Other = 'other'
}

/** ExerciseRoutineEnum */
export enum ExerciseRoutineEnum {
  Regular = 'regular',
  Occasional = 'occasional',
  Rarely = 'rarely',
  NotCurrentlyExercising = 'not_currently_exercising',
  Other = 'other'
}
/** DietTypeEnum */
export enum DietTypeEnum {
  NoSpecificDiet = 'no_specific_diet',
  Vegetarian = 'vegetarian',
  Vegan = 'vegan',
  Pescatarian = 'pescatarian',
  GlutenFree = 'gluten_free',
  DairyFree = 'dairy_free',
  LowCarbKeto = 'low_carb_keto',
  Other = 'other'
}

/** EatingPatternEnum */
export enum EatingPatternEnum {
  RegularMeals = 'regular_meals',
  IntermittentFasting = 'intermittent_fasting',
  SmallFrequentMeals = 'small_frequent_meals',
  SkipsMealsOften = 'skips_meals_often',
  VariesDaily = 'varies_daily',
  Other = 'other'
}

/** ActivityLevelEnum */
export enum ActivityLevelEnum {
  VERY_ACTIVE = 'VERY_ACTIVE',
  MODERATELY_ACTIVE = 'MODERATELY_ACTIVE',
  OCCASIONALLY_ACTIVE = 'OCCASIONALLY_ACTIVE',
  NOT_ACTIVE = 'NOT_ACTIVE'
}

/** CalmingActivityEnum */
export enum CalmingActivityEnum {
  Meditation = 'meditation',
  YogaStretching = 'yoga_stretching',
  Journaling = 'journaling',
  Breathwork = 'breathwork',
  Other = 'other',
  None = 'none'
}

/** ActivateDoctorRequest */
export interface ActivateDoctorRequest {
  /**
   * Doctor Id
   * @format uuid
   */
  doctor_id: string;
}

/** ActivateDoctorResponse */
export interface ActivateDoctorResponse {
  status: ResponseStatusEnum;
}

/** ActivateMemberRequest */
export interface ActivateMemberRequest {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
}

/** ActivateMemberResponse */
export interface ActivateMemberResponse {
  status: ResponseStatusEnum;
}

/** ActivateNutritionistRequest */
export interface ActivateNutritionistRequest {
  /**
   * Nutritionist Id
   * @format uuid
   */
  nutritionist_id: string;
}

/** ActivateNutritionistResponse */
export interface ActivateNutritionistResponse {
  status: ResponseStatusEnum;
}

/** AddressModel */
export interface AddressModel {
  /** Full Address */
  full_address: string;
  /** Postcode */
  postcode: string;
  /** City */
  city: string;
}

/** AdviceResponseElement */
export interface AdviceResponseElement {
  /** Id */
  id: number;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  body_system: BodySystem;
  /** Description */
  description: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Title */
  title?: string | null;
}

/** AppointmentBookingRecord */
export interface AppointmentBookingRecord {
  /** Booking Id */
  booking_id: number;
  /** Booking Code */
  booking_code: string;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** Patient User Id */
  patient_user_id: string;
  /** Id */
  id?: number | null;
  /** Appointment Id */
  appointment_id?: number | null;
}

/** AppointmentMemberInfo */
export interface AppointmentMemberInfo {
  /** Id */
  id: number;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Membership Type */
  membership_type?: string | null;
}

/** AssignDoctorRequestPydantic */
export interface AssignDoctorRequestPydantic {
  /**
   * Doctor Id
   * @format uuid
   */
  doctor_id: string;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
}

/** AssignDoctorResponse */
export interface AssignDoctorResponse {
  status: ResponseStatusEnum;
}

/** AssignFileToMemberRequest */
export interface AssignFileToMemberRequest {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** File Key */
  file_key: string;
}

/** AssignFileToMemberResponse */
export interface AssignFileToMemberResponse {
  status: ResponseStatusEnum;
}

/** AssignNutritionistRequestPydantic */
export interface AssignNutritionistRequestPydantic {
  /**
   * Nutritionist Id
   * @format uuid
   */
  nutritionist_id: string;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
}

/** AssignNutritionistResponse */
export interface AssignNutritionistResponse {
  status: ResponseStatusEnum;
}

/** AssignInChargeAdminRequestPydantic */
export interface AssignInChargeAdminRequestPydantic {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /**
   * Admin Id
   * @format uuid
   */
  admin_id: string;
}

/** AssignInChargeAdminResponse */
export interface AssignInChargeAdminResponse {
  status: ResponseStatusEnum;
}

/** AssignRecommendationRequestPydantic */
export interface AssignRecommendationRequestPydantic {
  /** Recommendation Id */
  recommendation_id: number;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
}

/** AssignRecommendationResponse */
export interface AssignRecommendationResponse {
  status: ResponseStatusEnum;
}

/** AuthorInResponse */
export interface AuthorInResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Role */
  role: string;
}

/** BSAdviceResponseElement */
export interface BSAdviceResponseElement {
  /** Id */
  id: number;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** Description */
  description: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Title */
  title?: string | null;
  notification: NotificationInResponseElement | null;
}

/** BasicsModel */
export interface BasicsModel {
  /**
   * Birth Date
   * @format date
   */
  birth_date: string;
  /** Email */
  email: string;
  /** Phone */
  phone: string;
  /** Weight */
  weight: number;
  weight_unit: WeightUnit;
  /** Height */
  height: number;
  height_unit: HeightUnit;
  biological_sex: UserGenderEnum;
  race_ethnicity: RaceEnum;
  address: AddressModel;
}

/** Biomarker */
export interface Biomarker {
  /** Name */
  name: string;
  /** Body Systems */
  body_systems: BodySystem[];
  /** Description */
  description: string;
  biomarker_type: BiomarkerType;
  /** Foods To Avoid */
  foods_to_avoid?: Food[];
  /** Foods To Eat */
  foods_to_eat?: Food[];
  /**
   * Age Dependent
   * @default false
   */
  age_dependent?: boolean | null;
  /**
   * Is Derived
   * @default false
   */
  is_derived?: boolean | null;
  /** Denominator Biomarker Id */
  denominator_biomarker_id?: number | null;
  /** Numerator Biomarker Id */
  numerator_biomarker_id?: number | null;
  scale_target?: DerivedBiomarkerScaleTarget | null;
  /** Scale Factor */
  scale_factor?: number | null;
  formula_type?: DerivedBiomarkerFormulaType | null;
  /** Formula Constant */
  formula_constant?: number | null;
  /** Formula Terms */
  formula_terms?: DerivedFormulaTerm[] | null;
  value_meaning?: BiomarkerValueMeaning | null;
  measurement_unit?: MeasurementUnits | null;
  /** Lab Bm Id */
  lab_bm_id?: string | null;
  /** Catalog Id */
  catalog_id?: string | null;
  /** Price */
  price?: number | null;
  /** Lifestyle Changes */
  lifestyle_changes?: string | null;
  /** Follow Up */
  follow_up?: string | null;
  /** Contraindications */
  contraindications?: string | null;
  /** Male Range Data */
  male_range_data?: Record<string, GenderRangeData> | GenderRangeData | any[];
  /** Female Range Data */
  female_range_data?: Record<string, GenderRangeData> | GenderRangeData | any[];
  /** Id */
  id?: number | null;
  /** Created At */
  created_at?: string | null;
}

/** BiomarkerElement */
export interface BiomarkerElement {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Body Systems */
  body_systems: BodySystem[];
  /** Foods To Avoid */
  foods_to_avoid: FoodInBiomarkerResponse[];
  /** Foods To Eat */
  foods_to_eat: FoodInBiomarkerResponse[];
  /** Description */
  description: string;
  /** Catalog Id */
  catalog_id?: string | null;
  /** Price */
  price?: number | null;
  /** Lifestyle Changes */
  lifestyle_changes: string;
  /** Follow Up */
  follow_up: string;
  /** Contraindications */
  contraindications: string;
  biomarker_type: BiomarkerType;
  measurement_unit?: MeasurementUnits | null;
  /**
   * Age Dependent
   * @default false
   */
  age_dependent?: boolean | null;
  /**
   * Is Derived
   * @default false
   */
  is_derived?: boolean | null;
  /** Denominator Biomarker Id */
  denominator_biomarker_id?: number | null;
  /** Numerator Biomarker Id */
  numerator_biomarker_id?: number | null;
  scale_target?: DerivedBiomarkerScaleTarget | null;
  /** Scale Factor */
  scale_factor?: number | null;
  formula_type?: DerivedBiomarkerFormulaType | null;
  /** Formula Constant */
  formula_constant?: number | null;
  /** Formula Terms */
  formula_terms?: DerivedFormulaTerm[] | null;
  value_meaning?: BiomarkerValueMeaning | null;
  /** Male Range Data */
  male_range_data?: Record<string, GenderRangeData> | GenderRangeData | any[];
  /** Female Range Data */
  female_range_data?: Record<string, GenderRangeData> | GenderRangeData | any[];
}

/** BiomarkerResultElement */
export interface BiomarkerResultElement {
  /** Value */
  value: string;
  /** Summary */
  summary: string;
  /** Biomarker Id */
  biomarker_id: number;
}

/** BodySystem */
export interface BodySystem {
  /** Icon */
  icon: string;
  /** Title */
  title: string;
  /** Description */
  description: string;
  /** Id */
  id?: number | null;
}

/** NumeratorResponse */
export interface NumeratorResponse {
  /** id */
  id: number;

  /** Name  */
  name: string
}

/** DenominatorResponse */
export interface DenominatorResponse {
  /** id */
  id: number;

  /** Name  */
  name: string
}

/** BodySystemResponse */
export interface BodySystemResponse {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Icon */
  icon: string;
  /** Description */
  description: string;
  /** Icon Url */
  icon_url: string;
}

/** Body_put_file_api_v1_file_storage_file_post */
export interface BodyPutFileApiV1FileStorageFilePost {
  /**
   * File
   * @format binary
   */
  file: File;
}

/** Body_put_photo_api_v1_file_storage_photo_post */
export interface BodyPutPhotoApiV1FileStoragePhotoPost {
  /**
   * File
   * @format binary
   */
  file: File;
}

/** Body_put_static_api_v1_file_storage_static_post */
export interface BodyPutStaticApiV1FileStorageStaticPost {
  /**
   * File
   * @format binary
   */
  file: File;
}

/** BookingData */
export interface BookingData {
  /** Id */
  id: number;
  /**
   * Time
   * @format date-time
   */
  time: string;
  pharma: PharmaInfo;
  user: UserInfo;
}

/** Clinic */
export interface Clinic {
  /** Id */
  id: number | null;
  /** Title */
  title: string;
  /** Address */
  address: string;
  /** Maps Link */
  maps_link?: string;
  phone_: Phone;
  email_?: Email;
  /** Description */
  description: string;
  image?: string;
  clinic_type?: string;
  gs_id?: string;
}

/** ClinicInAppointmentResponse */
export interface ClinicInAppointmentResponse {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Address */
  address: string;
  /** Maps Link */
  maps_link: string;
  /** Phone */
  phone: string;
  /** Email */
  email: string;
  /** Description */
  description: string;
}

/** CompleteMemberResponse */
export interface CompleteMemberResponse {
  /** Booking Token */
  booking_token: string;
  status: ResponseStatusEnum;
  /** Onboarding Form Completed */
  onboarding_form_completed?: boolean;
  /**
   * Onboarding Form Completed At
   * @format date-time
   */
  onboarding_form_completed_at?: string | null;
}

/** CountUnprocessedBiomarkerResultsResponse */
export interface CountUnprocessedBiomarkerResultsResponse {
  /** Count */
  count: number;
}

/** CounterResponse */
export interface CounterResponse {
  /** Total Count */
  total_count: number;
}

/** CreateAdviceRequest */
export interface CreateAdviceRequest {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** Body System Id */
  body_system_id: number;
  /** Description */
  description: string;
  /** Title */
  title?: string | null;
}

/** CreateAdviceResponse */
export interface CreateAdviceResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** CreateAppointmentRequestPydantic */
export interface CreateAppointmentRequestPydantic {
  /** Title */
  title: string;
  location: LocationType;
  /**
   * Scheduled Time
   * @format date-time
   */
  scheduled_time: string;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** @default "DATE_SCHEDULED" */
  status?: AppointmentStatus;
  /** Meeting Url */
  meeting_url?: string | null;
  /** Clinic Id */
  clinic_id?: number | null;
  /** Preparation Text */
  preparation_text?: string | null;
  assignee?: AppointmentAssigneeRequestPydantic | null;
}

/** CreateAppointmentResponse */
export interface CreateAppointmentResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** CreateBiomarkerRequest */
export interface CreateBiomarkerRequest {
  /** Name */
  name: string;
  /** Body System Ids */
  body_system_ids: number[];
  measurement_unit?: MeasurementUnits | null;
  /** @default "RANGES" */
  biomarker_type?: BiomarkerType;
  value_meaning?: BiomarkerValueMeaning | null;
  /** Foods To Avoid Ids */
  foods_to_avoid_ids?: number[];
  /** Foods To Eat Ids */
  foods_to_eat_ids?: number[];
  /** Blood Panels */
  blood_panels?: string[];
  /** Lab Bm Id */
  lab_bm_id?: string | null;
  /** Catalog Id */
  catalog_id?: string | null;
  /** Price */
  price?: number | null;
  /** Description */
  description?: string | null;
  /** Lifestyle Changes */
  lifestyle_changes?: string | null;
  /** Follow Up */
  follow_up?: string | null;
  /** Contraindications */
  contraindications?: string | null;
  /**
   * Age Dependent
   * @default false
   */
  age_dependent?: boolean | null;
  /**
   * Is Derived
   * @default false
   */
  is_derived?: boolean | null;
  /** Denominator Biomarker Id */
  denominator_biomarker_id?: number | null;
  /** Numerator Biomarker Id */
  numerator_biomarker_id?: number | null;
  scale_target?: DerivedBiomarkerScaleTarget | null;
  /** Scale Factor */
  scale_factor?: number | null;
  formula_type?: DerivedBiomarkerFormulaType | null;
  /** Formula Constant */
  formula_constant?: number | null;
  /** Formula Terms */
  formula_terms?: DerivedFormulaTerm[] | null;
  /** Male Range Data */
  male_range_data?:
  | GenderRangeDataInRequest
  | Record<string, GenderRangeDataInRequest>
  | null;
  /** Female Range Data */
  female_range_data?:
  | GenderRangeDataInRequest
  | Record<string, GenderRangeDataInRequest>
  | null;
  low_high_good?: BiomarkerLowHighGood | null;
}

/** CreateBiomarkerResponse */
export interface CreateBiomarkerResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** CreateBiomarkerResultRequest */
export interface CreateBiomarkerResultRequest {
  /** Appointment Id */
  appointment_id: number;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** Biomarkers */
  biomarkers: BiomarkerResultElement[];
}

/** CreateBiomarkerResultResponse */
export interface CreateBiomarkerResultResponse {
  status: ResponseStatusEnum;
}

/** CreateBodySystemRequest */
export interface CreateBodySystemRequest {
  /** Icon */
  icon: string;
  /** Title */
  title: string;
  /** Description */
  description: string;
  /** Applicable Modalities */
  applicable_modalities?: string[];
}

/** CreateBodySystemResponse */
export interface CreateBodySystemResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** CreateClinicRequestPydantic */
export interface CreateClinicRequestPydantic {
  /** Title */
  title: string;
  /** Address */
  address: string;
  /** Phone */
  phone: string;
  /** Email */
  email?: string | null;
  /** Description */
  description: string;
  /** Maps Link */
  maps_link?: string | null;
  image?: string | null;
  clinic_type?: string | null;
  gs_id?: string | null;
}

/** CreateClinicResponse */
export interface CreateClinicResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** CreateDietDiaryRequestPydantic */
export interface CreateDietDiaryRequestPydantic {
  meal_type: MealType;
  /** Note */
  note: string;
  /**
   * Meal Time
   * @format date-time
   */
  meal_time: string;
}

/** CreateDietDiaryResponse */
export interface CreateDietDiaryResponse {
  /** Id */
  id: number;
  meal_type: MealType;
  /** Note */
  note: string;
  /**
   * Meal Time
   * @format date-time
   */
  meal_time: string;
  status: ResponseStatusEnum;
}

/** CreateDoctorRequestPydantic */
export interface CreateDoctorRequestPydantic {
  /** Email */
  email: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Phone */
  phone?: string | null;
  /** Bio */
  bio: string;
  /** Photo */
  photo: string;
  specialization: DoctorSpecializationEnum;
  /** Calendly Url */
  calendly_url?: string | null;
  /** Blood Consult Calendly Url */
  blood_consult_calendly_url?: string | null;
  /** FBS Consult Calendly Url */
  fbs_consult_calendly_url?: string | null;
  /** Pre Scan Consult Calendly Url */
  pre_scan_consult_calendly_url?: string | null;
  /**
   * Team Id
   * @format uuid
   */
  team_id?: string | null;
}

/** CreateFAQRequest */
export interface CreateFAQRequest {
  /** Question */
  question: string;
  /** Answer */
  answer: string;
  /** Category Id */
  category_id?: number | null;
  /** New Category Title */
  new_category_title?: string | null;
}

/** CreateFAQResponse */
export interface CreateFAQResponse {
  status: ResponseStatusEnum;
  /** Faq Id */
  faq_id: number;
}

/** CreateFoodRequest */
export interface CreateFoodRequest {
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Image */
  image: string;
}

/** CreateFoodResponse */
export interface CreateFoodResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** CreateHealthSummaryRequestPydantic */
export interface CreateHealthSummaryRequestPydantic {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** Body System Id */
  body_system_id: number;
  /** Details */
  details: string;
}

/** CreateHealthSummaryResponse */
export interface CreateHealthSummaryResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** CreateMemberRequestPydantic */
export interface CreateMemberRequestPydantic {
  /** Email */
  email: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Phone */
  phone?: string | null;


  subscription_end?: string;
  /**
   * Is Paid
   * @default false
   */
  is_paid?: boolean;
  /** Membership Type */
  membership_type?: string;
}

/** CreateNoteRequest */
export interface CreateNoteRequest {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** Description */
  description: string;
  /** Title */
  title?: string | null;
  /**
   * Is Private
   * @default false
   */
  is_private?: boolean;
  /**
   * Mentioned User Ids
   * @format uuid
   */
  mentioned_user_ids?: string[];
}

/** CreateNoteResponse */
export interface CreateNoteResponse {
  /** Id */
  id: number;
  /** Description */
  description: string;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  author: AuthorInResponse;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Title */
  title?: string | null;
  /**
   * Is Private
   * @default false
   */
  is_private?: boolean;
  /**
   * Mentioned User Ids
   * @format uuid
   */
  mentioned_user_ids?: string[];
}

/** CreateNutritionistRequestPydantic */
export interface CreateNutritionistRequestPydantic {
  /** Email */
  email: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Phone */
  phone?: string | null;
  /** Bio */
  bio: string;
  /** Photo */
  photo: string;
  /** Calendly Url */
  calendly_url?: string | null;
  /**
   * Team Id
   * @format uuid
   */
  team_id?: string | null;
}

/** CreateRecommendationRequest */
export interface CreateRecommendationRequest {
  /** Title */
  title: string;
  /** Description */
  description: string;
  /** Image */
  image: string;
  /** Category Id */
  category_id: number;
}

/** CreateRecommendationResponse */
export interface CreateRecommendationResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** CreateSubscriptionRequest */
export interface CreateSubscriptionRequest {
  /** Promocode */
  promocode: string | null;
}

/** CreateSubscriptionResponse */
export interface CreateSubscriptionResponse {
  /** Client Secret */
  client_secret?: string | null;
  /** Subscription Id */
  subscription_id: string;
  /** Customer Id */
  customer_id: string;
  /** Amount */
  amount: number;
  payment_intent: PaymentIntentDetails;
  /** Setup Intent Client Secret */
  setup_intent_client_secret?: string | null;
  /** Setup Intent Id */
  setup_intent_id?: string | null;
  /** Subscription Name */
  subscription_name?: string | null;
  /** Billing Cycle */
  billing_cycle?: string | null;
}

/** CreateTuliBookingRequest */
export interface CreateTuliBookingRequest {
  /** Pharmacy Id */
  pharmacy_id: number;
  /** Test Date */
  test_date: string;
}

/** CreateTuliBookingResponse */
export interface CreateTuliBookingResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** CreateUserResponse */
export interface CreateUserResponse {
  /** Email */
  email: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  status: ResponseStatusEnum;
  /** Phone */
  phone?: string | null;
}

/** DeactivateDoctorRequest */
export interface DeactivateDoctorRequest {
  /**
   * Doctor Id
   * @format uuid
   */
  doctor_id: string;
}

/** DeactivateDoctorResponse */
export interface DeactivateDoctorResponse {
  status: ResponseStatusEnum;
}

/** DeactivateMemberRequest */
export interface DeactivateMemberRequest {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
}

/** DeactivateMemberResponse */
export interface DeactivateMemberResponse {
  status: ResponseStatusEnum;
}

/** DeactivateNutritionistRequest */
export interface DeactivateNutritionistRequest {
  /**
   * Nutritionist Id
   * @format uuid
   */
  nutritionist_id: string;
}

/** DeactivateNutritionistResponse */
export interface DeactivateNutritionistResponse {
  status: ResponseStatusEnum;
}

/** DeleteBiomarkerRequest */
export interface DeleteBiomarkerRequest {
  /** Id */
  id: number;
}

/** DeleteBiomarkerResultRequest */
export interface DeleteBiomarkerResultRequest {
  /** Result Ids */
  result_ids: number[];
}

/** DeleteFAQRequest */
export interface DeleteFAQRequest {
  /** Faq Id */
  faq_id: number;
}

/** DeleteFilesRequest */
export interface DeleteFilesRequest {
  /** File Keys */
  file_keys?: string[];
}

/** DeleteFoodRequest */
export interface DeleteFoodRequest {
  /** Id */
  id: number;
}

/** DeleteNoteRequest */
export interface DeleteNoteRequest {
  /** Note Id */
  note_id: number;
}

/** DeleteNutritionistRequest */
export interface DeleteNutritionistRequest {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
}

/** DeleteRecommendationRequest */
export interface DeleteRecommendationRequest {
  /** Id */
  id: number;
}

/** DoctorInAppointmentResponse */
export interface DoctorInAppointmentResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Photo */
  photo: string;
}

/** DoctorInMemberProfileResponse */
export interface DoctorInMemberProfileResponse {
  /**
   * Id
   * @format uuid
   */
  id_: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  specialization: DoctorSpecializationEnum;
  /** Photo */
  photo?: string | null;
  /** Photo Url */
  photo_url?: string | null;
}

/** DoctorInMemberResponse */
export interface DoctorInMemberResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Photo */
  photo?: string | null;
  /** Photo Url */
  photo_url?: string | null;
  /** Calendly Url */
  calendly_url?: string | null;
}

/** DoctorInMembersListResponse */
export interface DoctorInMembersListResponse {
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
}

/** EditFAQRequest */
export interface EditFAQRequest {
  /** Faq Id */
  faq_id: number;
  /** Category Id */
  category_id?: number | null;
  /** New Category Title */
  new_category_title?: string | null;
  /** Question */
  question?: string | null;
  /** Answer */
  answer?: string | null;
}

/** EditFAQResponse */
export interface EditFAQResponse {
  /** Faq Id */
  faq_id: number;
  status: ResponseStatusEnum;
}

/** EditNoteRequest */
export interface EditNoteRequest {
  /** Note Id */
  note_id: number;
  /** Description */
  description?: string | null;
  /** Title */
  title?: string | null;
  /** Is Private */
  is_private?: boolean | null;
  /**
   * Mentioned User Ids
   * @format uuid
   */
  mentioned_user_ids?: string[];
}

/** EditNoteResponse */
export interface EditNoteResponse {
  status: ResponseStatusEnum;
}

/** Email */
export interface Email {
  /** Value */
  value: string;
}

/** ExceptionSchema */
export interface ExceptionSchema {
  /** Description */
  description: string;
}

/** FAQElementResponse */
export interface FAQElementResponse {
  /** Id */
  id: number;
  /** Question */
  question: string;
  /** Answer */
  answer: string;
}

/** FamilyHistorySectionModel */
export interface FamilyHistorySectionModel {
  /** Family History Details */
  family_history_details?: string | null;
}

/** FemaleSexHormonesModel */
export interface FemaleSexHormonesModel {
  /** Last Period Date */
  last_period_date?: string | null;
  /** Hormonal Contraception Hrt */
  hormonal_contraception_hrt?: string | null;
  /** Typical Cycle Length */
  typical_cycle_length?: string | null;
  /** Primary Testing Reason */
  primary_testing_reason?: string | null;
  /** Menstrual Flow Characteristics */
  menstrual_flow_characteristics?: string | null;
  /** Menopause Details */
  menopause_details?: string | null;
  /** Additional Notes For Clinical Team */
  additional_notes_for_clinical_team?: string | null;
}

/** FileDTO */
export interface FileDTO {
  /** Key */
  key: string;
  /** Url */
  url: string;
  /**
   * Last Modified
   * @format date-time
   */
  last_modified: string;
}

/** FileKeyResponse */
export interface FileKeyResponse {
  /** Full Key */
  full_key: string;
}

/** Food */
export interface Food {
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Image */
  image: string;
  /** Image Url */
  image_url?: string | null;
  /** Id */
  id?: number | null;
}

/** FoodInBiomarkerResponse */
export interface FoodInBiomarkerResponse {
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Image */
  image: string;
  /** Image Url */
  image_url: string;
  /** Id */
  id: number;
}

/** GenderRangeData */
export interface GenderRangeData {
  gender: UserGenderEnum;
  /** Critical Low From */
  critical_low_from?: number | null;
  /** Critical Low From **/
  below_optimal_from?: number | null;
  /** Critical Low To */
  critical_low_to?: number | null;
  /** Critical Low To **/
  below_optimal_to?: number | null;
  /** Low From */
  low_from?: number | null;
  /** Low To */
  low_to?: number | null;
  /** Optimal From */
  optimal_from?: number | null;
  /** Optimal To */
  optimal_to?: number | null;
  /** High From */
  high_from?: number | null;
  above_optimal_from?: number | null;
  above_optimal_to?: number | null;
  /** High To */
  high_to?: number | null;
  /** Critical High From */
  critical_high_from?: number | null;
  /** Critical High To */
  critical_high_to?: number | null;
  /** Age Range */
  age_range?: string | null;
  /** Id */
  id?: number | null;
}

/** GenderRangeDataInRequest */
export interface GenderRangeDataInRequest {
  /** Critical Low From */
  critical_low_from?: number | null;
  below_optimal_from?: number | null;
  /** Critical Low To */
  critical_low_to?: number | null;
  below_optimal_to?: number | null;
  /** Low From */
  low_from?: number | null;
  /** Low To */
  low_to?: number | null;
  /** Optimal From */
  optimal_from?: number | null;
  /** Optimal To */
  optimal_to?: number | null;
  /** High From */
  high_from?: number | null;
  /** High To */
  high_to?: number | null;
  /** Critical High From */
  critical_high_from?: number | null;
  above_optimal_from?: number | null;
  /** Critical High To */
  critical_high_to?: number | null;
  above_optimal_to?: number | null;
}

/** GetAdviceListResponse */
export interface GetAdviceListResponse {
  /** Advices */
  advices: AdviceResponseElement[];
}

/** GetAdviceResponse */
export interface GetAdviceResponse {
  /** Id */
  id: number;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  body_system: BodySystem;
  /** Description */
  description: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Title */
  title?: string | null;
}

/** GetBSMemberAdvicesResponse */
export interface GetBSMemberAdvicesResponse {
  /** Advices */
  advices: BSAdviceResponseElement[];
}

/** GetBSMemberHealthSummaryResponse */
export interface GetBSMemberHealthSummaryResponse {
  /** Id */
  id?: number | null;
  /** Details */
  details?: string | null;
  notification?: AppScenariosHealthSummaryGetMemberBsHsApplicationPayloadNotificationInResponse | null;
}

/**  GetBiologicalAgeWrapper */
export interface GetBiologicalAgeWrapper {
  biological_age: GetBiologicalAgeResponse;
}

/** GetBiologicalAgeResponse */
export interface GetBiologicalAgeResponse {
  label: 'Unknown' | 'Excellent' | 'Good' | 'Average' | 'Below Average' | 'Poor';
  value: number;
  member_id: string;
  created_at: string;
  is_published?: boolean;
}

/** GetClinicResponse */
export interface GetClinicResponse {
  /** Clinic Id */
  clinic_id: number;
  /** Title */
  title: string;
  /** Address */
  address: string;
  /** Maps Link */
  maps_link: string;
  /** Phone */
  phone: string;
  /** Email */
  email: string;
  /** Description */
  description: string;
}

/** GetDoctorResponse */
export interface GetDoctorResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email: string;
  /** Is Active */
  is_active: boolean;
  /** Bio */
  bio: string;
  specialization: DoctorSpecializationEnum;
  /** Photo */
  photo?: string | null;
  /** Photo Url */
  photo_url?: string | null;
  /** Calendly Url */
  calendly_url?: string | null;
  /** Phone */
  phone?: string | null;
}

/** GetExistingBiomarkerResultsByAppointmentResponse */
export interface GetExistingBiomarkerResultsByAppointmentResponse {
  /** Biomarker Ids */
  biomarker_ids: number[];
}

/** GetHealthSummariesResponse */
export interface GetHealthSummariesResponse {
  /** Health Summaries */
  health_summaries: HealthSummaryResponseElement[];
}

/** GetMedicalCardResponse */
export interface GetMedicalCardResponse {
  /** Basics */
  basics?: object | null;
  /** Health Lifestyle */
  health_lifestyle?: object | null;
  /** Nutritionist Questions */
  nutritionist_questions?: object | null;
  /** Family History */
  family_history?: object | null;
  /** Goals */
  goals?: object | null;
  /** Female Sex Hormones */
  female_sex_hormones?: object | null;
  /** Created At */
  created_at?: string | null;
  /** Scan Info */
  scan_info?: Record<string, unknown> | null;
}

/** GetMemberProfileResponse */
export interface GetMemberProfileResponse {
  /**
   * Id
   * @format uuid
   */
  id_: string;
  /** Unique Id */
  unique_id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email: string;
  /** Is Active */
  is_active: boolean;
  /** Phone */
  phone: string;
  /**
   * Subscription End
   * @format date-time
   */
  subscription_end: string;
  gender?: UserGenderEnum | null;
  doctor?: DoctorInMemberProfileResponse | null;
  nutritionist?: NutritionistInMemberProfileResponse | null;
  /** Stripe Customer Id */
  stripe_customer_id?: string | null;
  /** Stripe Payment Method Id */
  stripe_payment_method_id?: string | null;
}

/** GetMemberResponse */
export interface GetMemberResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Unique Id */
  unique_id: string;
  /** Email */
  email: string;
  /** Is Active */
  is_active: boolean;
  /** Is Paid */
  is_paid: boolean;
  /** Phone */
  phone: string;
  gender: UserGenderEnum;
  /**
   * Subscription End
   * @format date-time
   */
  subscription_end: string;
  doctor?: DoctorInMemberResponse | null;
  nutritionist?: NutritionistInMemberResponse | null;
  in_charge_admin?: InChargeAdminOnMember | null;
  /** Address Line 1 */
  address_line_1?: string | null;
  /** Address Line 2 */
  address_line_2?: string | null;
  /** City */
  city?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** Country */
  country?: string | null;
  /** Dob */
  dob?: string | null;
  /** Notifications Disabled */
  notifications_disabled?: boolean;
  subscription?: AppScenariosUserMemberGetMemberApplicationPayloadSubscriptionInMemberResponse | null;
  /** Membership Type */
  membership_type?: string;
  is_vip?: boolean;
  /** Tags */
  tags?: Tag[];
}

/** GetNotesCountResponse */
export interface GetNotesCountResponse {
  /** Count */
  count: number;
}

/** GetNutritionistResponse */
export interface GetNutritionistResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email: string;
  /** Is Active */
  is_active: boolean;
  /** Bio */
  bio: string;
  /** Phone */
  phone?: string | null;
  /** Photo */
  photo?: string | null;
  /** Photo Url */
  photo_url?: string | null;
}

/** GetTuliBookingInfoResponse */
export interface GetTuliBookingInfoResponse {
  /** Data */
  data: BookingData[];
  status: ResponseStatusEnum;
}

/** GetUnprocessedBiomarkerResultsResponse */
export interface GetUnprocessedBiomarkerResultsResponse {
  /** Appointments */
  appointments: UnprocessedBiomarkerElement[];
}

/** GoalsSectionModel */
export interface GoalsSectionModel {
  /**
   * Goals
   * @default []
   */
  goals?: GoalsOption[];
  /**
   * Health Concerns
   * @default []
   */
  health_concerns?: HealthConcernOption[];
  /** Last Blood Test */
  last_blood_test?: string | null;
  /** Additional Info */
  additional_info?: string | null;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** HealthLifestyleModel */
export interface HealthLifestyleModel {
  overall_health: OverallHealthEnum;
  /** Medical Conditions */
  medical_conditions?: string | null;
  /** Allergies */
  allergies?: string | null;
  /** Medications */
  medications?: string | null;
  /** Supplements */
  supplements?: string | null;
  activity_level?: ActivityLevelEnum | null;
  exercise_frequency?: ExerciseFrequencyEnum | null;
  smoking_status?: SmokeUseEnum | null;
  alcohol_frequency?: AlcoholFrequencyEnum | null;
  working_style?: WorkingStyleEnum | null;
  other_working_style?: string | null;
  diet_types?: DietTypeEnum[] | null;
  other_diet_type?: string | null;
  eating_pattern?: EatingPatternEnum | null;
  other_eating_pattern?: string | null;
  /**
   * Pregnancy
   * @default false
   */
  pregnancy?: boolean;
  /** Any Specific */
  any_specific?: string | null;
}

/** HealthSummaryResponseElement */
export interface HealthSummaryResponseElement {
  /** Id */
  id: number;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  body_system: BodySystem;
  /** Details */
  details: string;
  /** Score */
  score?: string | null;
}

/** BodySystemGenerationResultPydantic */
export interface BodySystemGenerationResultPydantic {
  body_system_id: number;
  body_system_title: string;
  summary?: string | null;
  score?: string | null;
  success: boolean;
  error?: string | null;
}

/** GenerateBodySystemSummariesResponsePydantic */
export interface GenerateBodySystemSummariesResponsePydantic {
  results: BodySystemGenerationResultPydantic[];
  success_count: number;
  failure_count: number;
}

/** HistoricalBiomarkerDataElement */
export interface HistoricalBiomarkerDataElement {
  /** Id */
  id: number;
  /**
   * Date
   * @format date-time
   */
  date: string;
  /** Value */
  value: string;
}

/** HistoricalDataResponse */
export interface HistoricalDataResponse {
  /** Historical Data */
  historical_data: HistoricalBiomarkerDataElement[];
}

/** InuviFileInfo */
export interface InuviFileInfo {
  /** Id */
  id: number;
  /** File Key */
  file_key: string;
  /** Download Url */
  download_url: string;
  /** Last Modified / Uploaded Date */
  last_modified?: string | null;
  /** Assigned Date */
  assigned_date?: string | null;
}

/** BiomarkerUsedResponse */
export interface BiomarkerUsed {
  biomarker_id: number;
  biomarker_name: string;
  value: number;
  coefficient: number;
  unit: string | null;
}

export interface BiologicalAgeAuditRecord {
  id: number;
  member_id: string;
  actual_age: number;
  calculated_bio_age: number;
  calculation_date: string;
  biomarkers_used: BiomarkerUsed[];
  label: 'Unknown' | 'Excellent' | 'Good' | 'Average' | 'Below Average' | 'Poor';
  status: 'not_published' | 'published';
  created_at: string;
  updated_at: string;
}

/** GetBiologicalAgeAuditResponse */
export interface GetBiologicalAgeAuditResponse {
  bio_ages: BiologicalAgeAuditRecord[];
}

/** PublishBioAgeResponse */
export interface PublishBioAgeResponse {
  success: boolean;
  message: string;
}

/** ListAllAppointmentsResponse */
export interface ListAllAppointmentsResponse {
  /** Appointments */
  appointments: AppScenariosAppointmentListAllAppointmentsApplicationPayloadAppointmentInResponse[];
  /** Total Count */
  total_count: number;
}

/** ListBiomarkerResponseElement */
export interface ListBiomarkerResponseElement {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Body Systems */
  body_systems: BodySystem[];
  biomarker_type: BiomarkerType;
  /** Foods To Avoid */
  foods_to_avoid: FoodInBiomarkerResponse[];
  /** Foods To Eat */
  foods_to_eat: FoodInBiomarkerResponse[];
  /** Blood Panels */
  blood_panels?: string[];
  /**
   * Age Dependent
   * @default false
   */
  age_dependent?: boolean | null;
  /**
   * Is Derived
   * @default false
   */
  is_derived?: boolean | null;
  /** Denominator Biomarker Id */
  denominator_biomarker_id?: number | null;
  /** Numerator Biomarker Id */
  numerator_biomarker_id?: number | null;
  numerator_biomarker?: NumeratorResponse | null;
  denominator_biomarker?: DenominatorResponse | null;
  scale_target?: DerivedBiomarkerScaleTarget | null;
  /** Scale Factor */
  scale_factor?: number | null;
  formula_type?: DerivedBiomarkerFormulaType | null;
  /** Formula Constant */
  formula_constant?: number | null;
  /** Formula Terms */
  formula_terms?: DerivedFormulaTerm[] | null;
  value_meaning?: BiomarkerValueMeaning | null;
  /** Description */
  description?: string | null;
  /** Lifestyle Changes */
  lifestyle_changes?: string | null;
  /** Follow Up */
  follow_up?: string | null;
  /** Contraindications */
  contraindications?: string | null;
  measurement_unit?: MeasurementUnits | null;
  /** Lab Bm Id */
  lab_bm_id?: string | null;
  /** Male Range Data */
  male_range_data?: Record<string, GenderRangeData> | GenderRangeData | any[];
  /** Female Range Data */
  female_range_data?: Record<string, GenderRangeData> | GenderRangeData | any[];
  /** Calculated Value */
  calculated_value?: string | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
  low_high_good?: BiomarkerLowHighGood | null;
  retest_time_period?: string | null;
}

/** ListBiomarkerResultsByBodySystemResponse */
export interface ListBiomarkerResultsByBodySystemResponse {
  /** Biomarkers */
  biomarkers: AppScenariosBiomarkerGetBiomarkerResultsByBodysystemApplicationPayloadBiomarkerWithResultDTO[];
}

/** ListBiomarkerWithResultsResponse */
export interface ListBiomarkerWithResultsResponse {
  /** Biomarkers */
  biomarkers: AppScenariosBiomarkerGetMemberResultsApplicationPayloadBiomarkerWithResultDTO[];
}

/** ListBiomarkersResponse */
export interface ListBiomarkersResponse {
  /** Biomarkers */
  biomarkers: ListBiomarkerResponseElement[];
}

/** BiomarkerInBodySystemResponse */
export interface BiomarkerInBodySystemResponse {
  /** Id */
  id: number;
  /** Name */
  name: string;
}

/** MriConditionInBodySystemResponse */
export interface MriConditionInBodySystemResponse {
  /** Id */
  id: number;
  /** Radiologist Body System Id */
  radiologist_body_system_id: number;
  /** Radiology Organ Id */
  radiology_organ_id: number;
  /** Radiologist Body System Name */
  radiologist_body_system_name: string;
  /** Radiology Organ Name */
  radiology_organ_name: string;
  /** Gender */
  gender: string;
  /** Condition Description */
  condition_description: string;
  /** Enabled */
  enabled: boolean;
  /** Guidelines */
  guidelines?: string | null;
}

/** BodySystemPromptField */
export type BodySystemPromptField = 'summary' | 'score';

/** BodySystemPromptInListResponse */
export interface BodySystemPromptInListResponse {
  /** Id */
  id: number;
  /** Field */
  field: BodySystemPromptField;
  /** System Prompt */
  system_prompt: string;
  /** Developer Prompt */
  developer_prompt: string;
  /** Context File */
  context_file?: string | null;
}

/** BodySystemPromptResponse */
export interface BodySystemPromptResponse {
  /** Id */
  id: number;
  /** Body System Id */
  body_system_id: number;
  /** Field */
  field: BodySystemPromptField;
  /** System Prompt */
  system_prompt: string;
  /** Developer Prompt */
  developer_prompt: string;
  /** Context File */
  context_file?: string | null;
  /** Context File Url */
  context_file_url?: string | null;
  /** Previous Version Count */
  previous_version_count?: number;
}

/** GetBodySystemPromptsResponse */
export interface GetBodySystemPromptsResponse {
  /** Prompts */
  prompts: BodySystemPromptResponse[];
}

/** UpsertBodySystemPromptRequest */
export interface UpsertBodySystemPromptRequest {
  /** System Prompt */
  system_prompt: string;
  /** Developer Prompt */
  developer_prompt: string;
  /** Context File */
  context_file?: string | null;
}

/** UpsertBodySystemPromptResponse */
export interface UpsertBodySystemPromptResponse {
  /** Id */
  id: number;
  /** Body System Id */
  body_system_id: number;
  /** Field */
  field: BodySystemPromptField;
  /** System Prompt */
  system_prompt: string;
  /** Developer Prompt */
  developer_prompt: string;
  /** Context File */
  context_file?: string | null;
  /** Context File Url */
  context_file_url?: string | null;
  /** Status */
  status: string;
  /** Previous Version Count */
  previous_version_count?: number;
}

/** BulkBodySystemGenerationJobPydantic */
export interface BulkBodySystemGenerationJobPydantic {
  /** Job Id */
  job_id: string;
  /** Body System Id */
  body_system_id: number;
  /** Body System Title */
  body_system_title: string;
  /** Status */
  status: 'queued' | 'running' | 'completed' | 'failed' | 'cancelled' | string;
  /** Trigger */
  trigger?: string | null;
  /** Field */
  field?: string | null;
  /** Concurrency */
  concurrency?: number;
  /** Total */
  total: number;
  /** Current */
  current?: number;
  /** Current Member Name */
  current_member_name?: string | null;
  /** Generated */
  generated?: number;
  /** Failed */
  failed?: number;
  /** Failed Names */
  failed_names?: string[];
  /** Started At */
  started_at: string;
  /** Finished At */
  finished_at?: string | null;
  /** Error */
  error?: string | null;
}

/** ActiveBulkBodySystemGenerationJobPydantic */
export interface ActiveBulkBodySystemGenerationJobPydantic {
  job?: BulkBodySystemGenerationJobPydantic | null;
}

/** SaveAndGenerateBodySystemPromptResponsePydantic */
export interface SaveAndGenerateBodySystemPromptResponsePydantic {
  prompt: UpsertBodySystemPromptResponse;
  job: BulkBodySystemGenerationJobPydantic;
}

/** ListBodySystemResponseElement */
export interface ListBodySystemResponseElement {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Icon */
  icon: string;
  /** Description */
  description: string;
  /** Icon Url */
  icon_url: string;
  /** Mri Conditions */
  mri_conditions?: MriConditionInBodySystemResponse[];
  /** Biomarkers */
  biomarkers?: BiomarkerInBodySystemResponse[];
  /** Applicable Modalities */
  applicable_modalities?: string[];
  /** Prompts (present when list is fetched with prompt=true) */
  prompts?: BodySystemPromptInListResponse[] | null;
}

/** ListBodySystemsResponse */
export interface ListBodySystemsResponse {
  /** Body Systems */
  body_systems: ListBodySystemResponseElement[];
}

/** ListCategoryFAQElement */
export interface ListCategoryFAQElement {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Faqs */
  faqs: FAQElementResponse[];
}

/** ListClinicResponseElement */
export interface ListClinicResponseElement {
  /** Id */
  id: number;
  /** Address */
  address: string;
  /** Title */
  title: string;
  /** Description */
  description: string;
  /** Maps Link */
  maps_link?: string | null;
  /** Email */
  email?: string | null;
  /** Phone */
  phone: string;

  image?: string | null;
  clinic_type?: string | null;
  gs_id?: string | null;
}

/** ListClinicsResponse */
export interface ListClinicsResponse {
  /** Clinics */
  clinics: ListClinicResponseElement[];
}

/** ListDietDiaryResponse */
export interface ListDietDiaryResponse {
  /** Diet Records */
  diet_records: ListDietDiaryResponseElement[];
}

/** ListDietDiaryResponseElement */
export interface ListDietDiaryResponseElement {
  /**
   * Meal Time
   * @format date-time
   */
  meal_time: string;
  meal_type: MealType;
  /** Note */
  note: string;
  /** Id */
  id: number;
}

/** ListDoctorMembersResponse */
export interface ListDoctorMembersResponse {
  /** Members */
  members: ListDoctorMembersResponseElement[];
}

/** ListDoctorMembersResponseElement */
export interface ListDoctorMembersResponseElement {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** First Name */
  first_name: string;
  /** Unique Id */
  unique_id: string;
  /** Last Name */
  last_name: string;
  /**
   * Subscription End
   * @format date-time
   */
  subscription_end: string;
  /** Is Active */
  is_active: boolean;
  doctor?: DoctorInMembersListResponse | null;
}

/** ListDoctorsResponse */
export interface ListDoctorsResponse {
  /** Doctors */
  doctors: ListDoctorsResponseElement[];
}

/** ListDoctorsResponseElement */
export interface ListDoctorsResponseElement {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email: string;
  /** Bio */
  bio: string;
  specialization: DoctorSpecializationEnum;
  /** Is Active */
  is_active: boolean;
  /** Members Count */
  members_count?: number | null;
  /** Members */
  members?: MemberInDoctorResponse[] | null;
  /** Phone */
  phone?: string | null;
  /** Photo Url */
  photo_url?: string | null;
  /** Photo */
  photo?: string | null;
  /** Calendly Url */
  calendly_url?: string | null;
  /** Blood Consult Calendly Url */
  blood_consult_calendly_url?: string | null;
  /** FBS Consult Calendly Url */
  fbs_consult_calendly_url?: string | null;
  /** Pre Scan Consult Calendly Url */
  pre_scan_consult_calendly_url?: string | null;
  /**
   * Team Id
   * @format uuid
   */
  team_id?: string | null;
  /** Team Name */
  team_name?: string | null;
}

/** ListFAQResponse */
export interface ListFAQResponse {
  /** Categories */
  categories: ListCategoryFAQElement[];
}

/** ListFoodsResponse */
export interface ListFoodsResponse {
  /** Foods */
  foods: Food[];
}

/** ListMemberAppointmentsResponse */
export interface ListMemberAppointmentsResponse {
  /** Appointments */
  appointments: AppScenariosAppointmentBasePayloadAppointmentInResponse[];
}

/** ListMemberInuviFilesResponse */
export interface ListMemberInuviFilesResponse {
  /** Files */
  files: InuviFileInfo[];
}

/** ListMemberNotificationsResponse */
export interface ListMemberNotificationsResponse {
  /** Notifications */
  notifications: NotificationResponseElement[];
}

/** ListMembersResponse */
export interface ListMembersResponse {
  /** Members */
  members: ListMembersResponseElement[];
  total_count?: number | string;
  active_count?: number;
  disabled_count?: number;
  free_count?: number;
  all_count?: number;
  scan_count: number;
  blood_count: number;
}

/** ListMembersResponseElement */
export interface ListMembersResponseElement {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Subscription End
   * @format date-time
   */
  subscription_end: string;
  /** Is Active */
  is_active: boolean;
  /** Is Paid */
  is_paid: boolean;
  /** Unique Id */
  unique_id: string;
  /** Assigned */
  is_assigned?: boolean;
  /** Dob */
  dob?: string | null;
  gender?: UserGenderEnum | null;
  doctor?: DoctorInMembersListResponse | null;
  nutritionist?: NutritionistInMembersListResponse | null;
  /** Assigned in-charge admin (member list / detail payloads use user_id) */
  in_charge_admin?: InChargeAdminOnMember | null;
  subscription?: AppScenariosUserMemberListMembersApplicationPayloadSubscriptionInMemberResponse | null;
  /** Membership Type */
  membership_type?: string;
  /** Membership Status */
  membership_status?: string | null;
  /** Follow-up status (customer inquiries tabs) */
  followup_status?: string | null;
  /** Latest follow-up comment */
  followup_comment?: string | null;
  /** Is Vip */
  is_vip?: boolean;
  /** Tags */
  tags?: Tag[];
}

/** In-charge admin embedded on member list/detail (API uses user_id) */
export interface InChargeAdminOnMember {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
}

/** InChargeAdminListItem — returned by GET .../in-charge-admin-list */
export interface InChargeAdminListItem {
  /**
   * Id (same value as user_id for admins)
   * @format uuid
   */
  id?: string;
  /**
   * User Id (some responses use this instead of id)
   * @format uuid
   */
  user_id?: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
}

/** ListInChargeAdminsResponse */
export interface ListInChargeAdminsResponse {
  /** Admins */
  admins: InChargeAdminListItem[];
}

/** ListNoteResponseElement */
export interface ListNoteResponseElement {
  /** Id */
  id: number;
  /** Description */
  description: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  author: AuthorInResponse;
  /** Title */
  title?: string | null;
  /**
   * Is Private
   * @default false
   */
  is_private?: boolean;
  /** Whether this note is a referral letter */
  is_referral_letter?: boolean;
}

/** ListNotesResponse */
export interface ListNotesResponse {
  /** Notes */
  notes: ListNoteResponseElement[];
}

/** ListNutritionistMembersResponse */
export interface ListNutritionistMembersResponse {
  /** Members */
  members: ListNutritionistMembersResponseElement[];
}

/** ListNutritionistMembersResponseElement */
export interface ListNutritionistMembersResponseElement {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /**
   * Subscription End
   * @format date-time
   */
  subscription_end: string;
  /** Is Active */
  is_active: boolean;
  /** Unique Id */
  unique_id: string;
  nutritionist?: NutritionistInMembersListResponse | null;
}

/** ListNutritionistsResponse */
export interface ListNutritionistsResponse {
  /** Nutritionists */
  nutritionists: ListNutritionistsResponseElement[];
}

/** ListNutritionistsResponseElement */
export interface ListNutritionistsResponseElement {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email: string;
  /** Bio */
  bio: string;
  /** Is Active */
  is_active: boolean;
  /** Members Count */
  members_count?: number | null;
  /** Members */
  members?: MemberInNutritionistResponse[] | null;
  /** Photo Url */
  photo_url?: string | null;
  /** Photo */
  photo?: string | null;
  /** Calendly Url */
  calendly_url?: string | null;
  /** Phone */
  phone?: string | null;
  /**
   * Team Id
   * @format uuid
   */
  team_id?: string | null;
  /** Team Name */
  team_name?: string | null;
}

/** ListRecommendationCategoriesResponse */
export interface ListRecommendationCategoriesResponse {
  /** Categories */
  categories: RecommendationCategory[];
}

/** ListRecommendationsResponse */
export interface ListRecommendationsResponse {
  /** Recommendations */
  recommendations: Recommendation[];
}

/** ListResultsByAppointmentResponse */
export interface ListResultsByAppointmentResponse {
  /** Biomarkers */
  biomarkers: AppScenariosBiomarkerGetResultsByAppointmentApplicationPayloadBiomarkerWithResultDTO[];
}

/** MedicalAnswerRequest */
export interface MedicalAnswerRequest {
  /** Question Id */
  question_id: number;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** Value */
  value: string;
  /** Value Option */
  value_option?: string | null;
  /** Unit */
  unit?: string | null;
}

/** MedicalAnswerResponse */
export interface MedicalAnswerResponse {
  /** Question Id */
  question_id: number;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** Value */
  value: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Value Option */
  value_option?: string | null;
  /** Unit */
  unit?: string | null;
}

/** MedicalAnswerResponseElement */
export interface MedicalAnswerResponseElement {
  /** Question Id */
  question_id: number;
  /** Value */
  value: string;
  /**
   * Timestamp
   * @format date-time
   */
  timestamp: string;
  /** Value Option */
  value_option?: string | null;
  /** Unit */
  unit?: string | null;
}

/** NutritionistQuestionsModel */
export interface NutritionistQuestionsModel {
  working_style?: WorkingStyleEnum | null;
  other_working_style?: string | null;
  diet_types?: DietTypeEnum[] | null;
  other_diet_type?: string | null;
  eating_pattern?: EatingPatternEnum | null;
  other_eating_pattern?: string | null;
  hydration?: HydrationEnum | null;
  other_hydration?: string | null;
  exercise_routine?: ExerciseRoutineEnum | null;
  other_exercise_routine?: string | null;
  calming_activities?: CalmingActivityEnum[] | null;
  other_calming_activity?: string | null;
}

/** MedicalCardForm */
export interface MedicalCardForm {
  basics: BasicsModel;
  health_lifestyle: HealthLifestyleModel;
  nutritionist_questions: NutritionistQuestionsModel;
  family_history: FamilyHistorySectionModel;
  goals: GoalsSectionModel;
  female_sex_hormones?: FemaleSexHormonesModel | null;
}

/** MedicalCardRequestPydantic */
export interface MedicalCardRequestPydantic {
  /** Token */
  token: string;
  medical_card: MedicalCardForm;
  /**
   * Onboarding Form Completed
   * Set true on final onboarding submit
   * @default false
   */
  onboarding_form_completed?: boolean;
}

/** MedicalQuestionResponseElement */
export interface MedicalQuestionResponseElement {
  /** Id */
  id: number;
  /** Body System */
  body_system: string;
  /** Name */
  name: string;
  /** Value Placeholder */
  value_placeholder: string;
  /** Value Type */
  value_type: string;
  /** Value Options */
  value_options: string[];
  /** Value Units */
  value_units: string[];
  /** Answers */
  answers: MedicalAnswerResponseElement[];
}

/** MedicalQuestionsResponse */
export interface MedicalQuestionsResponse {
  /** Data */
  data?: Record<string, MedicalQuestionResponseElement[]>;
}

/** MemberInAppointmentResponse */
export interface MemberInAppointmentResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Email */
  email: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Is Active */
  is_active: boolean;
  role: UserRoleEnum;
  /** Phone */
  phone: string;
  /**
   * Dob
   * @format date
   */
  dob: string;
  gender: UserGenderEnum;
  /** Allergies */
  allergies: string[];
  /**
   * Subscription End
   * @format date-time
   */
  subscription_end: string;
  doctor?: DoctorInAppointmentResponse | null;
}

/** MemberInDoctorResponse */
export interface MemberInDoctorResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email: string;
  /** Phone */
  phone: string;
}

/** MemberInNutritionistResponse */
export interface MemberInNutritionistResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Email */
  email: string;
  /** Phone */
  phone: string;
}

/** MobileDeviceRequest */
export interface MobileDeviceRequest {
  /**
   * Device Id
   * @format uuid
   */
  device_id: string;
  /** Token */
  token: string;
}

/** MobileDeviceResponse */
export interface MobileDeviceResponse {
  /** Id */
  id: number;
  /** Token */
  token: string;
}

/** NotificationInResponseElement */
export interface NotificationInResponseElement {
  /** Notification Id */
  notification_id: number;
  /** Advice Id */
  advice_id: number;
  /** Is Read */
  is_read: boolean;
}

/** NotificationResponseElement */
export interface NotificationResponseElement {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Body */
  body: string;
  type: NotificationType;
  /** Metadata */
  metadata: object;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Is Read */
  is_read: boolean;
}

/** NutritionistInMemberProfileResponse */
export interface NutritionistInMemberProfileResponse {
  /**
   * Id
   * @format uuid
   */
  id_: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Photo */
  photo?: string | null;
  /** Photo Url */
  photo_url?: string | null;
}

/** NutritionistInMemberResponse */
export interface NutritionistInMemberResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
  /** Photo */
  photo?: string | null;
  /** Photo Url */
  photo_url?: string | null;
  /** Calendly Url */
  calendly_url?: string | null;
}

/** NutritionistInMembersListResponse */
export interface NutritionistInMembersListResponse {
  /** First Name */
  first_name: string;
  /** Last Name */
  last_name: string;
}

/** PaymentIntentDetails */
export interface PaymentIntentDetails {
  /** Client Secret */
  client_secret?: string | null;
  /** Payment Intent Id */
  payment_intent_id?: string | null;
  /** Amount */
  amount?: number | null;
  /** Currency */
  currency?: string | null;
  /** Status */
  status?: string | null;
  /** Payment Method Types */
  payment_method_types?: string[];
}

/** PharmaInfo */
export interface PharmaInfo {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Address1 */
  address1: string;
  /** City */
  city: string;
  /** Post Code */
  post_code: string;
  /** Phone */
  phone: string;
  /** Lat */
  lat: number;
  /** Lon */
  lon: number;
}

/** PharmacyAvailableSlotsResponse */
export interface PharmacyAvailableSlotsResponse {
  /** Free Slots */
  free_slots: object;
}

/** Phone */
export interface Phone {
  /** Value */
  value: string;
}

/** ReadNotificationRequest */
export interface ReadNotificationRequest {
  /** Notification Id */
  notification_id: number;
}

/** ReadNotificationResponse */
export interface ReadNotificationResponse {
  status: ResponseStatusEnum;
}

/** Recommendation */
export interface Recommendation {
  /** Title */
  title: string;
  /** Description */
  description: string;
  /** Image */
  image: string;
  category?: RecommendationCategory | null;
  /** Image Url */
  image_url?: string | null;
  /** Id */
  id?: number | null;
}

/** RecommendationCategory */
export interface RecommendationCategory {
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Icon */
  icon: string;
  /** Id */
  id?: number | null;
}

/** ResendPaymentLinkRequest */
export interface ResendPaymentLinkRequest {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
}

/** ResendPaymentLinkResponse */
export interface ResendPaymentLinkResponse {
  status: ResponseStatusEnum;
}

/** ResendQuestionnaireRequest */
export interface ResendQuestionnaireRequest {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
}

/** ResendQuestionnaireResponse */
export interface ResendQuestionnaireResponse {
  status: ResponseStatusEnum;
}

/** ResendTuliBookingRequest */
export interface ResendTuliBookingRequest {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
}

/** ResendTuliBookingResponse */
export interface ResendTuliBookingResponse {
  status: ResponseStatusEnum;
}

/** S3PutPhotoResponse */
export interface S3PutPhotoResponse {
  /** Full Key */
  full_key: string;
}

/** S3PutStaticResponse */
export interface S3PutStaticResponse {
  /** Full Key */
  full_key: string;
}

/** SearchPharmacyResponse */
export interface SearchPharmacyResponse {
  /** Pharmacies */
  pharmacies: object[];
}

/** SendDoctorAppointmentLinkRequest */
export interface SendDoctorAppointmentLinkRequest {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
}

/** SendDoctorAppointmentLinkResponse */
export interface SendDoctorAppointmentLinkResponse {
  status: ResponseStatusEnum;
}

/** SendNutritionistAppointmentLinkRequest */
export interface SendNutritionistAppointmentLinkRequest {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
}

/** SendNutritionistAppointmentLinkResponse */
export interface SendNutritionistAppointmentLinkResponse {
  status: ResponseStatusEnum;
}

/** SetBiomarkerResultStatusRequest */
export interface SetBiomarkerResultStatusRequest {
  /** Appointment Id */
  appointment_id: number;
  /** Results Ids */
  results_ids: number[];
  status: BiomarkerResultStatus;
}

/** SetBiomarkerResultStatusResponse */
export interface SetBiomarkerResultStatusResponse {
  status: ResponseStatusEnum;
}

/** SetMemberAddressRequestPydantic */
export interface SetMemberAddressRequestPydantic {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** Address Line 1 */
  address_line_1?: string | null;
  /** Address Line 2 */
  address_line_2?: string | null;
  /** City */
  city?: string | null;
  /** Post Code */
  post_code?: string | null;
  /** Country */
  country?: string | null;
}

/** SetMemberAddressResponse */
export interface SetMemberAddressResponse {
  status: ResponseStatusEnum;
}

/** SetMemberTZInfoRequest */
export interface SetMemberTZInfoRequest {
  /** Tz Info */
  tz_info: string;
}

/** SetMemberTZInfoResponse */
export interface SetMemberTZInfoResponse {
  status: ResponseStatusEnum;
}

/** SignOutRequestPydantic */
export interface SignOutRequestPydantic {
  /** Access Token */
  access_token: string;
  /** Refresh Token */
  refresh_token: string;
}

/** SignOutResponse */
export interface SignOutResponse {
  status: ResponseStatusEnum;
}

/** TokenResponse */
export interface TokenResponse {
  /** Access Token */
  access_token: string;
  /** Refresh Token */
  refresh_token: string;
}

/** UnassignRecommendationRequestPydantic */
export interface UnassignRecommendationRequestPydantic {
  /** Recommendation Id */
  recommendation_id: number;
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
}

/** UnassignRecommendationResponse */
export interface UnassignRecommendationResponse {
  status: ResponseStatusEnum;
}

/** UnprocessedBiomarkerElement */
export interface UnprocessedBiomarkerElement {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  /** Member Name */
  member_name: string;
  /**
   * Member Dob
   * @format date-time
   */
  member_dob: string;
  /**
   * Appointment Date
   * @format date-time
   */
  appointment_date: string;
  /** Appointment Id */
  appointment_id: number;
  /** Results Count */
  results_count: number;
  status: BiomarkerResultStatus;
}

/** UpdateAdviceRequest */
export interface UpdateAdviceRequest {
  /** Advice Id */
  advice_id: number;
  /** Body System Id */
  body_system_id: number | null;
  /** Description */
  description: string | null;
  /** Title */
  title: string | null;
}

/** UpdateAdviceResponse */
export interface UpdateAdviceResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** UpdateAppointmentRequestPydantic */
export interface UpdateAppointmentRequestPydantic {
  /** Appointment Id */
  appointment_id: number;
  /** Title */
  title?: string | null;
  location?: LocationType | null;
  status?: AppointmentStatus | null;
  /** Preparation Text */
  preparation_text?: string | null;
  /** Scheduled Time */
  scheduled_time?: string | null;
  /** Meeting Url */
  meeting_url?: string | null;
  /** Clinic Id */
  clinic_id?: number | null;
  /** Member Id */
  member_id?: string | null;
  assignee?: AppointmentAssigneeRequestPydantic | null;
}

export interface AppointmentAssigneeRequestPydantic {
  type: AppointmentAssigneeType;
  id: string;
}

/** UpdateAppointmentResponse */
export interface UpdateAppointmentResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** UpdateBiomarkerRequest */
export interface UpdateBiomarkerRequest {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Body System Ids */
  body_system_ids: number[];
  /** Foods To Avoid Ids */
  foods_to_avoid_ids: number[];
  /** Foods To Eat Ids */
  foods_to_eat_ids: number[];
  /** Blood Panels */
  blood_panels?: string[];
  measurement_unit?: MeasurementUnits | null;
  /** Lab Bm Id */
  lab_bm_id?: string | null;
  /** Catalog Id */
  catalog_id?: string | null;
  /** Price */
  price?: number | null;
  /** Description */
  description?: string | null;
  /** Lifestyle Changes */
  lifestyle_changes?: string | null;
  /** Follow Up */
  follow_up?: string | null;
  /** Contraindications */
  contraindications?: string | null;
  /**
   * Age Dependent
   * @default false
   */
  age_dependent?: boolean | null;
  /**
   * Is Derived
   * @default false
   */
  is_derived?: boolean | null;
  /** Denominator Biomarker Id */
  denominator_biomarker_id?: number | null;
  /** Numerator Biomarker Id */
  numerator_biomarker_id?: number | null;
  scale_target?: DerivedBiomarkerScaleTarget | null;
  /** Scale Factor */
  scale_factor?: number | null;
  formula_type?: DerivedBiomarkerFormulaType | null;
  /** Formula Constant */
  formula_constant?: number | null;
  /** Formula Terms */
  formula_terms?: DerivedFormulaTerm[] | null;
  biomarker_type?: BiomarkerType | null;
  value_meaning?: BiomarkerValueMeaning | null;
  /** Male Range Data */
  male_range_data?:
  | GenderRangeDataInRequest
  | Record<string, GenderRangeDataInRequest>
  | null;
  /** Female Range Data */
  female_range_data?:
  | GenderRangeDataInRequest
  | Record<string, GenderRangeDataInRequest>
  | null;
  low_high_good?: BiomarkerLowHighGood | null;
}

/** UpdateBiomarkerResponse */
export interface UpdateBiomarkerResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** UpdateBiomarkerStatusRequest */
export interface UpdateBiomarkerStatusRequest {
  /** Id */
  id: number;
  /** Is Active */
  is_active: boolean;
}

/** UpdateBiomarkerStatusResponse */
export interface UpdateBiomarkerStatusResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** UpdateBiomarkerResultElement */
export interface UpdateBiomarkerResultElement {
  /** Biomarker Result Id */
  biomarker_result_id: number;
  /** Value */
  value?: string | null;
  /** Summary */
  summary?: string | null;
}

/** UpdateBiomarkerResultRequest */
export interface UpdateBiomarkerResultRequest {
  /** Biomarkers */
  biomarkers: UpdateBiomarkerResultElement[];
}

/** UpdateBiomarkerResultResponse */
export interface UpdateBiomarkerResultResponse {
  status: ResponseStatusEnum;
}

/** UpdateBodySystemRequest */
export interface UpdateBodySystemRequest {
  /** Id */
  id: number;
  /** Icon */
  icon?: string | null;
  /** Title */
  title?: string | null;
  /** Description */
  description?: string | null;
  /** Applicable Modalities */
  applicable_modalities?: string[] | null;
}

/** UpdateBodySystemResponse */
export interface UpdateBodySystemResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** UpdateClinicRequestPydantic */
export interface UpdateClinicRequestPydantic {
  /** Clinic Id */
  clinic_id: number;
  /** Email */
  email?: string | null;
  /** Phone */
  phone?: string | null;
  /** Title */
  title?: string | null;
  /** Description */
  description?: string | null;
  /** Maps Link */
  maps_link?: string | null;
  /** Address */
  address?: string | null;

  image?: string | null;
  clinic_type?: string | null;
  gs_id?: string | null;
}

/** UpdateClinicResponse */
export interface UpdateClinicResponse {
  /** Clinic Id */
  clinic_id: number;
  status: ResponseStatusEnum;
}

/** UpdateDoctorRequestPydantic */
export interface UpdateDoctorRequestPydantic {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Bio */
  bio?: string | null;
  /** Photo */
  photo?: string | null;
  /** Email */
  email?: string | null;
  /** Phone */
  phone?: string | null;
  specialization?: DoctorSpecializationEnum | null;
  /** Calendly Url */
  calendly_url?: string | null;
  /** Blood Consult Calendly Url */
  blood_consult_calendly_url?: string | null;
  /** FBS Consult Calendly Url */
  fbs_consult_calendly_url?: string | null;
  /** Pre Scan Consult Calendly Url */
  pre_scan_consult_calendly_url?: string | null;
  /**
   * Team Id
   * @format uuid
   */
  team_id?: string | null;
}

/** UpdateDoctorResponse */
export interface UpdateDoctorResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  status: ResponseStatusEnum;
}

/** UpdateFoodRequest */
export interface UpdateFoodRequest {
  /** Id */
  id: number;
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
  /** Image */
  image?: string | null;
  /** Image Url */
  image_url?: string | null;
}

/** UpdateFoodResponse */
export interface UpdateFoodResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** UpdateHealthSummaryRequest */
export interface UpdateHealthSummaryRequest {
  /** Health Summary Id */
  health_summary_id: number;
  /** Body System Id */
  body_system_id: number | null;
  /** Details */
  details: string | null;
}

/** UpdateHealthSummaryResponse */
export interface UpdateHealthSummaryResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** UpdateMedicalCardRequestPydantic */
export interface UpdateMedicalCardRequestPydantic {
  /**
   * Member Id
   * @format uuid
   */
  member_id: string;
  medical_card: MedicalCardForm;
}

/** UpdateMedicalCardResponse */
export interface UpdateMedicalCardResponse {
  status: ResponseStatusEnum;
}

/** UpdateMemberRequestPydantic */
export interface UpdateMemberRequestPydantic {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Email */
  email?: string | null;
  /** Phone */
  phone?: string | null;
  /** Dob */
  dob?: string | null;
  gender?: UserGenderEnum | null;
  /** Subscription End */
  subscription_end?: string | null;
  /** Membership Type */
  membership_type?: string | null;
  /** Membership Status */
  membership_status?: string | null;
  /** Follow-up status */
  followup_status?: string | null;
  /** Follow-up comment (required when setting followup_status) */
  followup_comment?: string | null;
  /** Notifications Disabled */
  notifications_disabled?: boolean | null;
}

/** UpdateMemberResponse */
export interface UpdateMemberResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  status: ResponseStatusEnum;
}

/** UpdateNutritionistRequestPydantic */
export interface UpdateNutritionistRequestPydantic {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  /** First Name */
  first_name?: string | null;
  /** Last Name */
  last_name?: string | null;
  /** Bio */
  bio?: string | null;
  /** Photo */
  photo?: string | null;
  /** Email */
  email?: string | null;
  /** Phone */
  phone?: string | null;
  /** Calendly Url */
  calendly_url?: string | null;
  /**
   * Team Id
   * @format uuid
   */
  team_id?: string | null;
}

/** UpdateNutritionistResponse */
export interface UpdateNutritionistResponse {
  /**
   * User Id
   * @format uuid
   */
  user_id: string;
  status: ResponseStatusEnum;
}

/** UpdateRecommendationRequest */
export interface UpdateRecommendationRequest {
  /** Id */
  id: number;
  /** Category Id */
  category_id?: number | null;
  /** Title */
  title?: string | null;
  /** Description */
  description?: string | null;
  /** Image */
  image?: string | null;
}

/** UpdateRecommendationResponse */
export interface UpdateRecommendationResponse {
  /** Id */
  id: number;
  status: ResponseStatusEnum;
}

/** UpdateSubscriptionRequest */
export interface UpdateSubscriptionRequest {
  /** Payment Intent Id */
  payment_intent_id: string;
}

/** UpdateSubscriptionResponse */
export interface UpdateSubscriptionResponse {
  /**
   * Success
   * @default true
   */
  success?: boolean;
}

/** UserInfo */
export interface UserInfo {
  /** Firstname */
  firstName: string;
  /** Lastname */
  lastName: string;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** WebhookResponse */
export interface WebhookResponse {
  /** Success */
  success: boolean;
}

/** AppointmentInResponse */
export interface AppScenariosAppointmentBasePayloadAppointmentInResponse {
  /** Id */
  id: number | null;
  /** Title */
  title: string;
  location: LocationType;
  status: AppointmentStatus;
  /** Unique Id */
  unique_id: string;
  /** Preparation Text */
  preparation_text: string;
  /**
   * Scheduled Time
   * @format date-time
   */
  scheduled_time: string;
  /** Meeting Url */
  meeting_url?: string | null;
  assignee_type?: AppointmentAssigneeType | null;
  assignee_id?: string | null;
  clinic?: ClinicInAppointmentResponse | null;
  member?: MemberInAppointmentResponse | null;
  /** Notifications */
  notifications?:
  | AppScenariosAppointmentBasePayloadNotificationInResponse[]
  | null;
  booking_record?: AppointmentBookingRecord | null;
}

/** NotificationInResponse */
export interface AppScenariosAppointmentBasePayloadNotificationInResponse {
  /** Notification Id */
  notification_id: number;
  /** Appointment Id */
  appointment_id: number;
  /** Is Read */
  is_read: boolean;
  /** Test Result Id */
  test_result_id?: number | null;
}

/** AppointmentInResponse */
export interface AppScenariosAppointmentListAllAppointmentsApplicationPayloadAppointmentInResponse {
  /** Id */
  id: number;
  /** Title */
  title: string;
  location: LocationType;
  /**
   * Scheduled Time
   * @format date-time
   */
  scheduled_time: string;
  member: AppointmentMemberInfo;
  status: AppointmentStatus;
  /** Unique Id */
  unique_id: string;
  /** Preparation Text */
  preparation_text?: string | null;
  clinic?: Clinic | null;
  assignee_type?: AppointmentAssigneeType | null;
  assignee_id?: string | null;
  /** Meeting Url */
  meeting_url?: string | null;
}

/** BiomarkerResultDTO */
export interface AppScenariosBiomarkerGetBiomarkerResultsByBodysystemApplicationPayloadBiomarkerResultDTO {
  /** Value */
  value: string;
  status: BiomarkerResultStatus;
  /**
   * Appointment Date
   * @format date-time
   */
  appointment_date: string;
  /** Summary */
  summary?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Id */
  id?: number | null;
}

/** BiomarkerWithResultDTO */
export interface AppScenariosBiomarkerGetBiomarkerResultsByBodysystemApplicationPayloadBiomarkerWithResultDTO {
  biomarker: Biomarker;
  result: AppScenariosBiomarkerGetBiomarkerResultsByBodysystemApplicationPayloadBiomarkerResultDTO;
}

/** BiomarkerDTO */
export interface AppScenariosBiomarkerGetMemberResultsApplicationPayloadBiomarkerDTO {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Description */
  description: string | null;
  /** Lifestyle Changes */
  lifestyle_changes: string | null;
  /** Follow Up */
  follow_up: string | null;
  /** Contraindications */
  contraindications: string | null;
  /** Measurement Unit */
  measurement_unit: string | null;
  /** Lab Bm Id */
  lab_bm_id: string | null;
  biomarker_type: BiomarkerType;
  /** Body Systems */
  body_systems: BodySystem[];
  /** Male Range Data */
  male_range_data?: Record<string, GenderRangeData> | GenderRangeData | any[];
  /** Female Range Data */
  female_range_data?: Record<string, GenderRangeData> | GenderRangeData | any[];
  /** Foods To Avoid */
  foods_to_avoid?: Food[];
  /** Foods To Eat */
  foods_to_eat?: Food[];
  value_meaning?: BiomarkerValueMeaning | null;
  /**
   * Age Dependent
   * @default false
   */
  age_dependent?: boolean | null;
  is_derived?: boolean | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
}

/** BiomarkerResultDTO */
export interface AppScenariosBiomarkerGetMemberResultsApplicationPayloadBiomarkerResultDTO {
  /** Value */
  value: string;
  status: BiomarkerResultStatus;
  /**
   * Appointment Date
   * @format date-time
   */
  appointment_date: string;
  /** Appointment Id */
  appointment_id: number;
  /** Appointment Unique Id */
  appointment_unique_id: string;
  /** Summary */
  summary?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Id */
  id?: number | null;
}

/** BiomarkerWithResultDTO */
export interface AppScenariosBiomarkerGetMemberResultsApplicationPayloadBiomarkerWithResultDTO {
  biomarker: AppScenariosBiomarkerGetMemberResultsApplicationPayloadBiomarkerDTO;
  result: AppScenariosBiomarkerGetMemberResultsApplicationPayloadBiomarkerResultDTO;
}

/** BiomarkerDTO */
export interface AppScenariosBiomarkerGetResultsByAppointmentApplicationPayloadBiomarkerDTO {
  /** Id */
  id: number | null;
  /** Name */
  name: string;
  /** Description */
  description: string;
  measurement_unit: MeasurementUnits | null;
  /** Body Systems */
  body_systems: BodySystem[];
  /** Foods To Avoid */
  foods_to_avoid?: Food[];
  /** Foods To Eat */
  foods_to_eat?: Food[];
  /** Male Range Data */
  male_range_data?: Record<string, GenderRangeData> | GenderRangeData | any[];
  /** Female Range Data */
  female_range_data?: Record<string, GenderRangeData> | GenderRangeData | any[];
  /** Lifestyle Changes */
  lifestyle_changes?: string | null;
  /** Follow Up */
  follow_up?: string | null;
  /** Contraindications */
  contraindications?: string | null;
  /** Value Meaning */
  value_meaning?: string | null;
  /**
   * Age Dependent
   * @default false
   */
  age_dependent?: boolean | null;
  /** Biomarker Type */
  biomarker_type?: string | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
}

/** BiomarkerResultDTO */
export interface AppScenariosBiomarkerGetResultsByAppointmentApplicationPayloadBiomarkerResultDTO {
  /** Value */
  value: string;
  status: BiomarkerResultStatus;
  /**
   * Appointment Date
   * @format date-time
   */
  appointment_date: string;
  /** Summary */
  summary?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Id */
  id?: number | null;
}

/** BiomarkerWithResultDTO */
export interface AppScenariosBiomarkerGetResultsByAppointmentApplicationPayloadBiomarkerWithResultDTO {
  biomarker: AppScenariosBiomarkerGetResultsByAppointmentApplicationPayloadBiomarkerDTO;
  result: AppScenariosBiomarkerGetResultsByAppointmentApplicationPayloadBiomarkerResultDTO;
}

/** NotificationInResponse */
export interface AppScenariosHealthSummaryGetMemberBsHsApplicationPayloadNotificationInResponse {
  /** Notification Id */
  notification_id: number;
  /** Is Read */
  is_read: boolean;
}

/** SubscriptionInMemberResponse */
export interface AppScenariosUserMemberGetMemberApplicationPayloadSubscriptionInMemberResponse {
  /**
   * Id
   * @format uuid
   */
  id: string;
  /** Status */
  status: string;
  /**
   * Current Period Start
   * @format date-time
   */
  current_period_start: string;
  /**
   * Current Period End
   * @format date-time
   */
  current_period_end: string;
  /** Cancel At Period End */
  cancel_at_period_end: boolean;
}

/** SubscriptionInMemberResponse */
export interface AppScenariosUserMemberListMembersApplicationPayloadSubscriptionInMemberResponse {
  /** Id */
  id: number;
  /** Status */
  status: string;
  /**
   * Current Period Start
   * @format date-time
   */
  current_period_start: string;
  /**
   * Current Period End
   * @format date-time
   */
  current_period_end: string;
  /** Cancel At Period End */
  cancel_at_period_end: boolean;
}

/** biomarkerAppointmentsResponse */
export interface biomarkerAppointmentsResponse {
  /** Appointment Dates */
  appointment_dates: string[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

/** Tags */
export interface Tag {
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Color */
  color: string;
  /** Is Active */
  is_active?: boolean;
  /** Id */
  id?: number | null;
}

/** CreateTagsRequest */
export interface CreateTagsRequest {
  /** Name */
  name: string;
  /** Description */
  description: string;
  /** Color */
  color: string;
}

/** UpdateTagsRequest */
export interface UpdateTagsRequest {
  /** Id */
  id: number;
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
  /** Color */
  color?: string | null;
  /** Is Active */
  is_active?: boolean | null;
}

/** ListTagsResponse */
export interface ListTagsResponse {
  /** Tags */
  tags: Tag[];
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer'
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => 'undefined' !== typeof query[key]
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {})
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body)
      }
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
          .then((data) => {
            if (r.ok) {
              r.data = data;
            } else {
              r.error = data;
            }
            return r;
          })
          .catch((e) => {
            r.error = e;
            return r;
          });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title CoreVitals
 * @version 1.0.0
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags General
     * @name HealthcheckApiV1Get
     * @summary Healthcheck
     * @request GET:/api/v1/
     */
    healthcheckApiV1Get: (params: RequestParams = {}) =>
      this.request<Record<string, string>, any>({
        path: `/api/v1/`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * @description Accepts Auth0 Bearer token
     *
     * @tags Auth
     * @name LoginApiV1AuthLoginPost
     * @summary Login
     * @request POST:/api/v1/auth/login
     * @secure
     */
    loginApiV1AuthLoginPost: (params: RequestParams = {}) =>
      this.request<TokenResponse, ExceptionSchema>({
        path: `/api/v1/auth/login`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name SignOutApiV1AuthSignOutPost
     * @summary Sign Out
     * @request POST:/api/v1/auth/sign-out
     * @secure
     */
    signOutApiV1AuthSignOutPost: (
      data: SignOutRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<SignOutResponse, HTTPValidationError>({
        path: `/api/v1/auth/sign-out`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name GetNewTokenPairApiV1AuthTokenGet
     * @summary Get New Token Pair
     * @request GET:/api/v1/auth/token
     * @secure
     */
    getNewTokenPairApiV1AuthTokenGet: (params: RequestParams = {}) =>
      this.request<TokenResponse, ExceptionSchema>({
        path: `/api/v1/auth/token`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name GetMembersListApiV1MembersListGet
     * @summary Get Members List
     * @request GET:/api/v1/members/list
     * @secure
     */
    getMembersListApiV1MembersListGet: (
      query?: {
        /**
         * Limit
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number;
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
        /** Loading Strategy */
        loading_strategy?: MemberLoadStrategy | null;
        /** Unique Id */
        unique_id?: string | null;
        /** Full Name */
        full_name?: string | null;
        /**
         * Subscribe
         * Filter members by subscription status
         */
        subscribe?: boolean | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ListMembersResponse, ExceptionSchema | HTTPValidationError>({
        path: `/api/v1/members/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name GetCurrentMemberProfileApiV1MembersGet
     * @summary Get Current Member Profile
     * @request GET:/api/v1/members/
     * @secure
     */
    getCurrentMemberProfileApiV1MembersGet: (
      query?: {
        /** Load Strategy */
        load_strategy?: MemberLoadStrategy | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        GetMemberProfileResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/members/`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name CreateMemberApiV1MembersPost
     * @summary Create Member
     * @request POST:/api/v1/members/
     * @secure
     */
    createMemberApiV1MembersPost: (
      data: CreateMemberRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<CreateUserResponse, HTTPValidationError>({
        path: `/api/v1/members/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name UpdateClientApiV1MembersPatch
     * @summary Update Client
     * @request PATCH:/api/v1/members/
     * @secure
     */
    updateClientApiV1MembersPatch: (
      data: UpdateMemberRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<UpdateMemberResponse, ExceptionSchema | HTTPValidationError>(
        {
          path: `/api/v1/members/`,
          method: 'PATCH',
          body: data,
          secure: true,
          type: ContentType.Json,
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags Members
     * @name GetMemberBiologicalAgeApiV1MembersBioAgeGet
     * @summary Get Member Biological Age
     * @request GET:/api/v1/members/bio-age
     * @secure
     */
    getMemberBiologicalAgeApiV1MembersBioAgeGet: (params: RequestParams = {}) =>
      this.request<GetBiologicalAgeResponse, ExceptionSchema>({
        path: `/api/v1/members/bio-age`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name GetMemberApiV1MembersUserIdGet
     * @summary Get Member
     * @request GET:/api/v1/members/{user_id}
     * @secure
     */
    getMemberApiV1MembersUserIdGet: (
      userId: string,
      query?: {
        /** Load Strategy */
        load_strategy?: MemberLoadStrategy | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetMemberResponse, ExceptionSchema | HTTPValidationError>({
        path: `/api/v1/members/${userId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name AssignDoctorToMemberApiV1MembersAssignDoctorPost
     * @summary Assign Doctor To Member
     * @request POST:/api/v1/members/assign-doctor
     * @secure
     */
    assignDoctorToMemberApiV1MembersAssignDoctorPost: (
      data: AssignDoctorRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<AssignDoctorResponse, HTTPValidationError>({
        path: `/api/v1/members/assign-doctor`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name AssignNutritionistToMemberApiV1MembersAssignNutritionistPost
     * @summary Assign Nutritionist To Member
     * @request POST:/api/v1/members/assign-nutritionist
     * @secure
     */
    assignNutritionistToMemberApiV1MembersAssignNutritionistPost: (
      data: AssignNutritionistRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<AssignNutritionistResponse, HTTPValidationError>({
        path: `/api/v1/members/assign-nutritionist`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name AssignRecommendationToMemberApiV1MembersAssignRecommendationPost
     * @summary Assign Recommendation To Member
     * @request POST:/api/v1/members/assign-recommendation
     * @secure
     */
    assignRecommendationToMemberApiV1MembersAssignRecommendationPost: (
      data: AssignRecommendationRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<AssignRecommendationResponse, HTTPValidationError>({
        path: `/api/v1/members/assign-recommendation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name SetMemberAddressApiV1MembersSetAddressPatch
     * @summary Set Member Address
     * @request PATCH:/api/v1/members/set-address
     * @secure
     */
    setMemberAddressApiV1MembersSetAddressPatch: (
      data: SetMemberAddressRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<SetMemberAddressResponse, HTTPValidationError>({
        path: `/api/v1/members/set-address`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name SetMemberTzInfoApiV1MembersSetTzInfoPatch
     * @summary Set Member Tz Info
     * @request PATCH:/api/v1/members/set-tz-info
     * @secure
     */
    setMemberTzInfoApiV1MembersSetTzInfoPatch: (
      data: SetMemberTZInfoRequest,
      params: RequestParams = {}
    ) =>
      this.request<SetMemberTZInfoResponse, HTTPValidationError>({
        path: `/api/v1/members/set-tz-info`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name GetMemberMedicalCardApiV1MembersMedicalCardUserIdGet
     * @summary Get Member Medical Card
     * @request GET:/api/v1/members/medical-card/{user_id}/
     * @secure
     */
    getMemberMedicalCardApiV1MembersMedicalCardUserIdGet: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        GetMedicalCardResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/members/medical-card/${userId}/`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name CompleteMemberFormApiV1MembersCompleteProfilePost
     * @summary Complete Member Form
     * @request POST:/api/v1/members/complete-profile
     */
    completeMemberFormApiV1MembersCompleteProfilePost: (
      data: MedicalCardRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<CompleteMemberResponse, HTTPValidationError>({
        path: `/api/v1/members/complete-profile`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name UpdateMemberMedicalCardApiV1MembersUpdateMedCardPatch
     * @summary Update Member Medical Card
     * @request PATCH:/api/v1/members/update/med-card
     * @secure
     */
    updateMemberMedicalCardApiV1MembersUpdateMedCardPatch: (
      data: UpdateMedicalCardRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<UpdateMedicalCardResponse, HTTPValidationError>({
        path: `/api/v1/members/update/med-card`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name RegisterMobileDeviceApiV1MembersRegisterDevicePost
     * @summary Register Mobile Device
     * @request POST:/api/v1/members/register-device
     * @secure
     */
    registerMobileDeviceApiV1MembersRegisterDevicePost: (
      data: MobileDeviceRequest,
      params: RequestParams = {}
    ) =>
      this.request<MobileDeviceResponse, ExceptionSchema | HTTPValidationError>(
        {
          path: `/api/v1/members/register-device`,
          method: 'POST',
          body: data,
          secure: true,
          type: ContentType.Json,
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags Members
     * @name ResendQuestionnaireApiV1MembersResendFormPost
     * @summary Resend Questionnaire
     * @request POST:/api/v1/members/resend-form
     * @secure
     */
    resendQuestionnaireApiV1MembersResendFormPost: (
      data: ResendQuestionnaireRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ResendQuestionnaireResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/members/resend-form`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name UnassignRecommendationFromMemberApiV1MembersUnassignRecommendationPost
     * @summary Unassign Recommendation From Member
     * @request POST:/api/v1/members/unassign-recommendation
     * @secure
     */
    unassignRecommendationFromMemberApiV1MembersUnassignRecommendationPost: (
      data: UnassignRecommendationRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<UnassignRecommendationResponse, HTTPValidationError>({
        path: `/api/v1/members/unassign-recommendation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name DeactivateMemberApiV1MembersDeactivatePatch
     * @summary Deactivate Member
     * @request PATCH:/api/v1/members/deactivate
     * @secure
     */
    deactivateMemberApiV1MembersDeactivatePatch: (
      data: DeactivateMemberRequest,
      params: RequestParams = {}
    ) =>
      this.request<DeactivateMemberResponse, HTTPValidationError>({
        path: `/api/v1/members/deactivate`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name ActivateMemberApiV1MembersActivatePatch
     * @summary Activate Member
     * @request PATCH:/api/v1/members/activate
     * @secure
     */
    activateMemberApiV1MembersActivatePatch: (
      data: ActivateMemberRequest,
      params: RequestParams = {}
    ) =>
      this.request<ActivateMemberResponse, HTTPValidationError>({
        path: `/api/v1/members/activate`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name ResendTuliBookingApiV1MembersResendTuliBookingPost
     * @summary Resend Tuli Booking
     * @request POST:/api/v1/members/resend-tuli-booking
     * @secure
     */
    resendTuliBookingApiV1MembersResendTuliBookingPost: (
      data: ResendTuliBookingRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ResendTuliBookingResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/members/resend-tuli-booking`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name AssignFileToMemberApiV1MembersAssignInuviFilePost
     * @summary Assign File To Member
     * @request POST:/api/v1/members/assign-inuvi-file
     * @secure
     */
    assignFileToMemberApiV1MembersAssignInuviFilePost: (
      data: AssignFileToMemberRequest,
      params: RequestParams = {}
    ) =>
      this.request<AssignFileToMemberResponse, HTTPValidationError>({
        path: `/api/v1/members/assign-inuvi-file`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name UnassignFileFromMemberApiV1MembersFilesFileIdDelete
     * @summary Unassign File From Member
     * @request DELETE:/api/v1/members/files/{file_id}
     * @secure
     */
    unassignFileFromMemberApiV1MembersFilesFileIdDelete: (
      fileId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/members/files/${fileId}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name ListMemberInuviFilesApiV1MembersMemberIdInuviFilesGet
     * @summary List Member Inuvi Files
     * @request GET:/api/v1/members/{member_id}/inuvi-files
     * @secure
     */
    listMemberInuviFilesApiV1MembersMemberIdInuviFilesGet: (
      memberId: string,
      params: RequestParams = {}
    ) =>
      this.request<ListMemberInuviFilesResponse, HTTPValidationError>({
        path: `/api/v1/members/${memberId}/inuvi-files`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name ResendPaymentLinkApiV1MembersResendPaymentLinkPost
     * @summary Resend Payment Link
     * @request POST:/api/v1/members/resend-payment-link
     * @secure
     */
    resendPaymentLinkApiV1MembersResendPaymentLinkPost: (
      data: ResendPaymentLinkRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ResendPaymentLinkResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/members/resend-payment-link`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name SendDoctorAppointmentLinkApiV1MembersSendDoctorLinkPost
     * @summary Send Doctor Appointment Link
     * @request POST:/api/v1/members/send-doctor-link
     * @secure
     */
    sendDoctorAppointmentLinkApiV1MembersSendDoctorLinkPost: (
      data: SendDoctorAppointmentLinkRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        SendDoctorAppointmentLinkResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/members/send-doctor-link`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Members
     * @name SendNutritionistAppointmentLinkApiV1MembersSendNutritionistLinkPost
     * @summary Send Nutritionist Appointment Link
     * @request POST:/api/v1/members/send-nutritionist-link
     * @secure
     */
    sendNutritionistAppointmentLinkApiV1MembersSendNutritionistLinkPost: (
      data: SendNutritionistAppointmentLinkRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        SendNutritionistAppointmentLinkResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/members/send-nutritionist-link`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Medical Questions
     * @name GetMedicalQuestionsListApiV1QuestionsListMemberIdGet
     * @summary Get Medical Questions List
     * @request GET:/api/v1/questions/list/{member_id}
     * @secure
     */
    getMedicalQuestionsListApiV1QuestionsListMemberIdGet: (
      memberId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        MedicalQuestionsResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/questions/list/${memberId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Medical Questions
     * @name AnswerQuestionApiV1QuestionsAnswerPost
     * @summary Answer Question
     * @request POST:/api/v1/questions/answer
     * @secure
     */
    answerQuestionApiV1QuestionsAnswerPost: (
      data: MedicalAnswerRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        MedicalAnswerResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/questions/answer`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Doctors
     * @name GetDoctorsListApiV1DoctorsListGet
     * @summary Get Doctors List
     * @request GET:/api/v1/doctors/list
     * @secure
     */
    getDoctorsListApiV1DoctorsListGet: (
      query: {
        /** Loading Strategy */
        loading_strategy?: DoctorLoadStrategy | null;
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<ListDoctorsResponse, ExceptionSchema | HTTPValidationError>({
        path: `/api/v1/doctors/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Doctors
     * @name GetDoctorMembersListApiV1DoctorsMembersGet
     * @summary Get Doctor Members List
     * @request GET:/api/v1/doctors/members
     * @secure
     */
    getDoctorMembersListApiV1DoctorsMembersGet: (
      query: {
        /** Loading Strategy */
        loading_strategy?: MemberLoadStrategy | null;
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ListDoctorMembersResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/doctors/members`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Doctors
     * @name GetDoctorApiV1DoctorsUserIdGet
     * @summary Get Doctor
     * @request GET:/api/v1/doctors/{user_id}
     * @secure
     */
    getDoctorApiV1DoctorsUserIdGet: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<GetDoctorResponse, ExceptionSchema | HTTPValidationError>({
        path: `/api/v1/doctors/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Doctors
     * @name CreateDoctorApiV1DoctorsPost
     * @summary Create Doctor
     * @request POST:/api/v1/doctors/
     * @secure
     */
    createDoctorApiV1DoctorsPost: (
      data: CreateDoctorRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<CreateUserResponse, HTTPValidationError>({
        path: `/api/v1/doctors/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Doctors
     * @name UpdateDoctorApiV1DoctorsPatch
     * @summary Update Doctor
     * @request PATCH:/api/v1/doctors/
     * @secure
     */
    updateDoctorApiV1DoctorsPatch: (
      data: UpdateDoctorRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<UpdateDoctorResponse, ExceptionSchema | HTTPValidationError>(
        {
          path: `/api/v1/doctors/`,
          method: 'PATCH',
          body: data,
          secure: true,
          type: ContentType.Json,
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags Doctors
     * @name DeactivateDoctorApiV1DoctorsDeactivatePatch
     * @summary Deactivate Doctor
     * @request PATCH:/api/v1/doctors/deactivate
     * @secure
     */
    deactivateDoctorApiV1DoctorsDeactivatePatch: (
      data: DeactivateDoctorRequest,
      params: RequestParams = {}
    ) =>
      this.request<DeactivateDoctorResponse, HTTPValidationError>({
        path: `/api/v1/doctors/deactivate`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Doctors
     * @name ActivateDoctorApiV1DoctorsActivatePatch
     * @summary Activate Doctor
     * @request PATCH:/api/v1/doctors/activate
     * @secure
     */
    activateDoctorApiV1DoctorsActivatePatch: (
      data: ActivateDoctorRequest,
      params: RequestParams = {}
    ) =>
      this.request<ActivateDoctorResponse, HTTPValidationError>({
        path: `/api/v1/doctors/activate`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Appointments
     * @name CreateAppointmentApiV1AppointmentPost
     * @summary Create Appointment
     * @request POST:/api/v1/appointment/
     * @secure
     */
    createAppointmentApiV1AppointmentPost: (
      data: CreateAppointmentRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<CreateAppointmentResponse, HTTPValidationError>({
        path: `/api/v1/appointment/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Appointments
     * @name GetAppointmentApiV1AppointmentGet
     * @summary Get Appointment
     * @request GET:/api/v1/appointment/
     * @secure
     */
    getAppointmentApiV1AppointmentGet: (
      query: {
        /** Appointment Id */
        appointment_id: number;
        /** Loading Strategy */
        loading_strategy?: AppointmentLoadStrategy | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        AppScenariosAppointmentBasePayloadAppointmentInResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/appointment/`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Appointments
     * @name UpdateAppointmentApiV1AppointmentPatch
     * @summary Update Appointment
     * @request PATCH:/api/v1/appointment/
     * @secure
     */
    updateAppointmentApiV1AppointmentPatch: (
      data: UpdateAppointmentRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<
        UpdateAppointmentResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/appointment/`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Appointments
     * @name GetAllAppointmentsApiV1AppointmentAllGet
     * @summary Get All Appointments
     * @request GET:/api/v1/appointment/all
     * @secure
     */
    getAllAppointmentsApiV1AppointmentAllGet: (
      query: {
        /**
         * Filter Type
         * @default "all"
         */
        filter_type?: 'all' | 'upcoming' | 'past';
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ListAllAppointmentsResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/appointment/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Appointments
     * @name DeleteAppointmentApiV1AppointmentAppointmentIdDelete
     * @summary Delete Appointment
     * @request DELETE:/api/v1/appointment/{appointment_id}
     * @secure
     */
    deleteAppointmentApiV1AppointmentAppointmentIdDelete: (
      appointmentId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/appointment/${appointmentId}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Appointments
     * @name GetMemberAppointmentsListApiV1AppointmentListGet
     * @summary Get Member Appointments List
     * @request GET:/api/v1/appointment/list
     * @secure
     */
    getMemberAppointmentsListApiV1AppointmentListGet: (
      query: {
        /**
         * Member Id
         * @format uuid
         */
        member_id: string;
        /** Loading Strategy */
        loading_strategy?: AppointmentLoadStrategy | null;
        /** Filters */
        filters?: AppointmentFilter | null;
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ListMemberAppointmentsResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/appointment/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Health Summary
     * @name CreateHealthSummaryApiV1HealthSummaryPost
     * @summary Create Health Summary
     * @request POST:/api/v1/health-summary/
     * @secure
     */
    createHealthSummaryApiV1HealthSummaryPost: (
      data: CreateHealthSummaryRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<CreateHealthSummaryResponse, HTTPValidationError>({
        path: `/api/v1/health-summary/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Health Summary
     * @name UpdateHealthSummaryApiV1HealthSummaryPatch
     * @summary Update Health Summary
     * @request PATCH:/api/v1/health-summary/
     * @secure
     */
    updateHealthSummaryApiV1HealthSummaryPatch: (
      data: UpdateHealthSummaryRequest,
      params: RequestParams = {}
    ) =>
      this.request<UpdateHealthSummaryResponse, HTTPValidationError>({
        path: `/api/v1/health-summary/`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Health Summary
     * @name GetMemberHealthSummariesApiV1HealthSummaryBsGet
     * @summary Get Member Health Summaries
     * @request GET:/api/v1/health-summary/bs
     * @secure
     */
    getMemberHealthSummariesApiV1HealthSummaryBsGet: (
      query: {
        /** Body System Id */
        body_system_id: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        GetBSMemberHealthSummaryResponse | null,
        HTTPValidationError
      >({
        path: `/api/v1/health-summary/bs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Health Summary
     * @name GetMemberBodySystemHealthSummaryApiV1HealthSummaryListGet
     * @summary Get Member Body System Health Summary
     * @request GET:/api/v1/health-summary/list
     * @secure
     */
    getMemberBodySystemHealthSummaryApiV1HealthSummaryListGet: (
      query: {
        /**
         * Member Id
         * @format uuid
         */
        member_id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetHealthSummariesResponse, HTTPValidationError>({
        path: `/api/v1/health-summary/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Body Systems
     * @name GetBodySystemApiV1BodySystemGet
     * @summary Get Body System
     * @request GET:/api/v1/body-system/
     * @secure
     */
    getBodySystemApiV1BodySystemGet: (
      query: {
        /** Bs Id */
        bs_id: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<BodySystemResponse, ExceptionSchema | HTTPValidationError>({
        path: `/api/v1/body-system/`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Body Systems
     * @name CreateBodySystemApiV1BodySystemPost
     * @summary Create Body System
     * @request POST:/api/v1/body-system/
     * @secure
     */
    createBodySystemApiV1BodySystemPost: (
      data: CreateBodySystemRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateBodySystemResponse, HTTPValidationError>({
        path: `/api/v1/body-system/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Body Systems
     * @name UpdateBodySystemApiV1BodySystemPatch
     * @summary Update Body System
     * @request PATCH:/api/v1/body-system/
     * @secure
     */
    updateBodySystemApiV1BodySystemPatch: (
      data: UpdateBodySystemRequest,
      params: RequestParams = {}
    ) =>
      this.request<UpdateBodySystemResponse, HTTPValidationError>({
        path: `/api/v1/body-system/`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Body Systems
     * @name GetBodySystemsListApiV1BodySystemListGet
     * @summary Get Body Systems List
     * @request GET:/api/v1/body-system/list
     * @secure
     */
    getBodySystemsListApiV1BodySystemListGet: (params: RequestParams = {}) =>
      this.request<ListBodySystemsResponse, ExceptionSchema>({
        path: `/api/v1/body-system/list`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Body Systems
     * @name DeleteBodySystemApiV1BodySystemBsIdDelete
     * @summary Delete Body System
     * @request DELETE:/api/v1/body-system/{bs_id}
     * @secure
     */
    deleteBodySystemApiV1BodySystemBsIdDelete: (
      bsId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/body-system/${bsId}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Biomarkers
     * @name GetBiomarkerApiV1BiomarkerGet
     * @summary Get Biomarker
     * @request GET:/api/v1/biomarker/
     * @secure
     */
    getBiomarkerApiV1BiomarkerGet: (
      query: {
        /** Biomarker Id */
        biomarker_id: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetBiomarkerResponse, HTTPValidationError>({
        path: `/api/v1/biomarker/`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Creates a new biomarker. male_range_data and female_range_data support two formats: - If age_dependent = true, the data must be a dictionary where the key is a string representing the age range (for example, '18-25') and the value is a range object. Example: male_range_data: { '18-25': { ...ranges... }, '26-35': { ...ranges... } } - If age_dependent = false, the data must be a single range object. Example: male_range_data: { ...ranges... }
     *
     * @tags Biomarkers
     * @name CreateBiomarkerApiV1BiomarkerPost
     * @summary Create a new biomarker
     * @request POST:/api/v1/biomarker/
     * @secure
     */
    createBiomarkerApiV1BiomarkerPost: (
      data: CreateBiomarkerRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateBiomarkerResponse, HTTPValidationError>({
        path: `/api/v1/biomarker/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Biomarkers
     * @name UpdateBiomarkerApiV1BiomarkerPatch
     * @summary Update Biomarker
     * @request PATCH:/api/v1/biomarker/
     * @secure
     */
    updateBiomarkerApiV1BiomarkerPatch: (
      data: UpdateBiomarkerRequest,
      params: RequestParams = {}
    ) =>
      this.request<UpdateBiomarkerResponse, HTTPValidationError>({
        path: `/api/v1/biomarker/`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Biomarkers
     * @name DeleteBiomarkerApiV1BiomarkerDelete
     * @summary Delete Biomarker
     * @request DELETE:/api/v1/biomarker/
     * @secure
     */
    deleteBiomarkerApiV1BiomarkerDelete: (
      data: DeleteBiomarkerRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/biomarker/`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Biomarkers
     * @name ListBiomarkersApiV1BiomarkerListGet
     * @summary List Biomarkers
     * @request GET:/api/v1/biomarker/list
     * @secure
     */
    listBiomarkersApiV1BiomarkerListGet: (
      query?: {
        /** Name */
        name?: string | null;
        /** Lab Bm Id */
        lab_bm_id?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ListBiomarkersResponse, HTTPValidationError>({
        path: `/api/v1/biomarker/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Biomarkers
     * @name CreateBiomarkerResultApiV1BiomarkerResultPost
     * @summary Create Biomarker Result
     * @request POST:/api/v1/biomarker/result
     * @secure
     */
    createBiomarkerResultApiV1BiomarkerResultPost: (
      data: CreateBiomarkerResultRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateBiomarkerResultResponse, HTTPValidationError>({
        path: `/api/v1/biomarker/result`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Biomarkers
     * @name UpdateBiomarkerResultApiV1BiomarkerResultPatch
     * @summary Update Biomarker Result
     * @request PATCH:/api/v1/biomarker/result
     * @secure
     */
    updateBiomarkerResultApiV1BiomarkerResultPatch: (
      data: UpdateBiomarkerResultRequest,
      params: RequestParams = {}
    ) =>
      this.request<UpdateBiomarkerResultResponse, HTTPValidationError>({
        path: `/api/v1/biomarker/result`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Biomarkers
     * @name DeleteBiomarkerResultApiV1BiomarkerResultDelete
     * @summary Delete Biomarker Result
     * @request DELETE:/api/v1/biomarker/result
     * @secure
     */
    deleteBiomarkerResultApiV1BiomarkerResultDelete: (
      data: DeleteBiomarkerResultRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/biomarker/result`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * @description Returns member approved biomarkers with results
     *
     * @tags Biomarkers
     * @name GetMemberBiomarkerResultsApiV1BiomarkerResultGet
     * @summary Get Member Biomarker Results
     * @request GET:/api/v1/biomarker/result
     * @secure
     */
    getMemberBiomarkerResultsApiV1BiomarkerResultGet: (
      query?: {
        /** Member Id */
        member_id?: string | null;
        /** Biomarker Name */
        biomarker_name?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ListBiomarkerWithResultsResponse, HTTPValidationError>({
        path: `/api/v1/biomarker/result`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns unprocessed biomarker results
     *
     * @tags Biomarkers
     * @name GetUnprocessedBiomarkerResultsApiV1BiomarkerResultUnprocessedGet
     * @summary Get Unprocessed Biomarker Results
     * @request GET:/api/v1/biomarker/result/unprocessed
     * @secure
     */
    getUnprocessedBiomarkerResultsApiV1BiomarkerResultUnprocessedGet: (
      params: RequestParams = {}
    ) =>
      this.request<GetUnprocessedBiomarkerResultsResponse, any>({
        path: `/api/v1/biomarker/result/unprocessed`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns biomarker results by appointment
     *
     * @tags Biomarkers
     * @name GetBiomarkerResultsByAppointmentApiV1BiomarkerResultByAppointmentGet
     * @summary Get Biomarker Results By Appointment
     * @request GET:/api/v1/biomarker/result/by-appointment
     * @secure
     */
    getBiomarkerResultsByAppointmentApiV1BiomarkerResultByAppointmentGet: (
      query: {
        /** Appointment Id */
        appointment_id: number;
        result_type: BiomarkerResultType;
      },
      params: RequestParams = {}
    ) =>
      this.request<ListResultsByAppointmentResponse, HTTPValidationError>({
        path: `/api/v1/biomarker/result/by-appointment`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns historical data by biomarker
     *
     * @tags Biomarkers
     * @name GetBiomarkerHistoricalDataApiV1BiomarkerResultHistoricalDataGet
     * @summary Get Biomarker Historical Data
     * @request GET:/api/v1/biomarker/result/historical-data
     * @secure
     */
    getBiomarkerHistoricalDataApiV1BiomarkerResultHistoricalDataGet: (
      query: {
        /** Biomarker Id */
        biomarker_id: number;
        /** Member Id */
        member_id?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<HistoricalDataResponse, HTTPValidationError>({
        path: `/api/v1/biomarker/result/historical-data`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Biomarkers
     * @name SetBiomarkerResultStatusApiV1BiomarkerResultSetStatusPatch
     * @summary Set Biomarker Result Status
     * @request PATCH:/api/v1/biomarker/result/set-status
     * @secure
     */
    setBiomarkerResultStatusApiV1BiomarkerResultSetStatusPatch: (
      data: SetBiomarkerResultStatusRequest,
      params: RequestParams = {}
    ) =>
      this.request<SetBiomarkerResultStatusResponse, HTTPValidationError>({
        path: `/api/v1/biomarker/result/set-status`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns existing biomarker ids by appointment
     *
     * @tags Biomarkers
     * @name GetExistingBiomarkerResultsByAppointmentApiV1BiomarkerResultExistingByAppointmentGet
     * @summary Get Existing Biomarker Results By Appointment
     * @request GET:/api/v1/biomarker/result/existing-by-appointment
     * @secure
     */
    getExistingBiomarkerResultsByAppointmentApiV1BiomarkerResultExistingByAppointmentGet:
      (
        query: {
          /** Appointment Id */
          appointment_id: number;
        },
        params: RequestParams = {}
      ) =>
        this.request<
          GetExistingBiomarkerResultsByAppointmentResponse,
          HTTPValidationError
        >({
          path: `/api/v1/biomarker/result/existing-by-appointment`,
          method: 'GET',
          query: query,
          secure: true,
          format: 'json',
          ...params
        }),

    /**
     * No description
     *
     * @tags Biomarkers
     * @name GetBiomarkerResultsByBsApiV1BiomarkerResultByBsGet
     * @summary Get Biomarker Results By Bs
     * @request GET:/api/v1/biomarker/result/by-bs
     * @secure
     */
    getBiomarkerResultsByBsApiV1BiomarkerResultByBsGet: (
      query: {
        /** Body System Id */
        body_system_id: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ListBiomarkerResultsByBodySystemResponse,
        HTTPValidationError
      >({
        path: `/api/v1/biomarker/result/by-bs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Food
     * @name CreateFoodApiV1FoodPost
     * @summary Create Food
     * @request POST:/api/v1/food/
     * @secure
     */
    createFoodApiV1FoodPost: (
      data: CreateFoodRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateFoodResponse, HTTPValidationError>({
        path: `/api/v1/food/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Food
     * @name DeleteFoodApiV1FoodDelete
     * @summary Delete Food
     * @request DELETE:/api/v1/food/
     * @secure
     */
    deleteFoodApiV1FoodDelete: (
      data: DeleteFoodRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/food/`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Food
     * @name UpdateFoodApiV1FoodPatch
     * @summary Update Food
     * @request PATCH:/api/v1/food/
     * @secure
     */
    updateFoodApiV1FoodPatch: (
      data: UpdateFoodRequest,
      params: RequestParams = {}
    ) =>
      this.request<UpdateFoodResponse, HTTPValidationError>({
        path: `/api/v1/food/`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Food
     * @name ListFoodsApiV1FoodListGet
     * @summary List Foods
     * @request GET:/api/v1/food/list
     * @secure
     */
    listFoodsApiV1FoodListGet: (
      query?: {
        /** Id */
        id?: number | null;
        /** Name */
        name?: string | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ListFoodsResponse, HTTPValidationError>({
        path: `/api/v1/food/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Clinics
     * @name GetClinicsListApiV1ClinicListGet
     * @summary Get Clinics List
     * @request GET:/api/v1/clinic/list
     * @secure
     */
    getClinicsListApiV1ClinicListGet: (
      query: {
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<ListClinicsResponse, ExceptionSchema | HTTPValidationError>({
        path: `/api/v1/clinic/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Clinics
     * @name GetClinicApiV1ClinicClinicIdGet
     * @summary Get Clinic
     * @request GET:/api/v1/clinic/{clinic_id}
     * @secure
     */
    getClinicApiV1ClinicClinicIdGet: (
      clinicId: number,
      params: RequestParams = {}
    ) =>
      this.request<GetClinicResponse, ExceptionSchema | HTTPValidationError>({
        path: `/api/v1/clinic/${clinicId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Clinics
     * @name CreateClinicApiV1ClinicPost
     * @summary Create Clinic
     * @request POST:/api/v1/clinic/
     * @secure
     */
    createClinicApiV1ClinicPost: (
      data: CreateClinicRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<CreateClinicResponse, HTTPValidationError>({
        path: `/api/v1/clinic/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Clinics
     * @name UpdateClinicApiV1ClinicPatch
     * @summary Update Clinic
     * @request PATCH:/api/v1/clinic/
     * @secure
     */
    updateClinicApiV1ClinicPatch: (
      data: UpdateClinicRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<UpdateClinicResponse, ExceptionSchema | HTTPValidationError>(
        {
          path: `/api/v1/clinic/`,
          method: 'PATCH',
          body: data,
          secure: true,
          type: ContentType.Json,
          format: 'json',
          ...params
        }
      ),

    /**
     * No description
     *
     * @tags Advice
     * @name CreateAdviceApiV1AdvicePost
     * @summary Create Advice
     * @request POST:/api/v1/advice/
     * @secure
     */
    createAdviceApiV1AdvicePost: (
      data: CreateAdviceRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateAdviceResponse, HTTPValidationError>({
        path: `/api/v1/advice/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Advice
     * @name UpdateAdviceApiV1AdvicePatch
     * @summary Update Advice
     * @request PATCH:/api/v1/advice/
     * @secure
     */
    updateAdviceApiV1AdvicePatch: (
      data: UpdateAdviceRequest,
      params: RequestParams = {}
    ) =>
      this.request<UpdateAdviceResponse, HTTPValidationError>({
        path: `/api/v1/advice/`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Advice
     * @name DeleteAdviceApiV1AdviceAdviceIdDelete
     * @summary Delete Advice
     * @request DELETE:/api/v1/advice/{advice_id}
     * @secure
     */
    deleteAdviceApiV1AdviceAdviceIdDelete: (
      adviceId: number,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/advice/${adviceId}`,
        method: 'DELETE',
        secure: true,
        ...params
      }),

    /**
     * No description
     *
     * @tags Advice
     * @name GetAdviceApiV1AdviceAdviceIdGet
     * @summary Get Advice
     * @request GET:/api/v1/advice/{advice_id}
     * @secure
     */
    getAdviceApiV1AdviceAdviceIdGet: (
      adviceId: number,
      params: RequestParams = {}
    ) =>
      this.request<GetAdviceResponse, HTTPValidationError>({
        path: `/api/v1/advice/${adviceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Advice
     * @name GetMemberAdvicesByBsApiV1AdviceBsGet
     * @summary Get Member Advices By Bs
     * @request GET:/api/v1/advice/bs
     * @secure
     */
    getMemberAdvicesByBsApiV1AdviceBsGet: (
      query: {
        /** Body System Id */
        body_system_id: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetBSMemberAdvicesResponse, HTTPValidationError>({
        path: `/api/v1/advice/bs`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Advice
     * @name GetMemberAdvicesApiV1AdviceListGet
     * @summary Get Member Advices
     * @request GET:/api/v1/advice/list
     * @secure
     */
    getMemberAdvicesApiV1AdviceListGet: (
      query: {
        /**
         * Member Id
         * @format uuid
         */
        member_id: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetAdviceListResponse, HTTPValidationError>({
        path: `/api/v1/advice/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diet Diary Records
     * @name CreateDietDiaryApiV1DietDiaryPost
     * @summary Create Diet Diary
     * @request POST:/api/v1/diet-diary/
     * @secure
     */
    createDietDiaryApiV1DietDiaryPost: (
      data: CreateDietDiaryRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<CreateDietDiaryResponse, HTTPValidationError>({
        path: `/api/v1/diet-diary/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Diet Diary Records
     * @name GetMemberDietRecordsApiV1DietDiaryListGet
     * @summary Get Member Diet Records
     * @request GET:/api/v1/diet-diary/list
     * @secure
     */
    getMemberDietRecordsApiV1DietDiaryListGet: (
      query: {
        /** Member Id */
        member_id?: string | null;
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ListDietDiaryResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/diet-diary/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Notes
     * @name CreateNoteApiV1NotesPost
     * @summary Create Note
     * @request POST:/api/v1/notes/
     * @secure
     */
    createNoteApiV1NotesPost: (
      data: CreateNoteRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateNoteResponse, HTTPValidationError>({
        path: `/api/v1/notes/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Notes
     * @name DeleteNoteApiV1NotesDelete
     * @summary Delete Note
     * @request DELETE:/api/v1/notes/
     * @secure
     */
    deleteNoteApiV1NotesDelete: (
      data: DeleteNoteRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/notes/`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Notes
     * @name EditNoteApiV1NotesPatch
     * @summary Edit Note
     * @request PATCH:/api/v1/notes/
     * @secure
     */
    editNoteApiV1NotesPatch: (
      data: EditNoteRequest,
      params: RequestParams = {}
    ) =>
      this.request<EditNoteResponse, HTTPValidationError>({
        path: `/api/v1/notes/`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Notes
     * @name GetMemberNotesApiV1NotesListGet
     * @summary Get Member Notes
     * @request GET:/api/v1/notes/list
     * @secure
     */
    getMemberNotesApiV1NotesListGet: (
      query: {
        /**
         * Member Id
         * @format uuid
         */
        member_id: string;
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<ListNotesResponse, ExceptionSchema | HTTPValidationError>({
        path: `/api/v1/notes/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags FAQs
     * @name CreateFaqApiV1FaqPost
     * @summary Create Faq
     * @request POST:/api/v1/faq/
     * @secure
     */
    createFaqApiV1FaqPost: (
      data: CreateFAQRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateFAQResponse, HTTPValidationError>({
        path: `/api/v1/faq/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags FAQs
     * @name DeleteFaqApiV1FaqDelete
     * @summary Delete Faq
     * @request DELETE:/api/v1/faq/
     * @secure
     */
    deleteFaqApiV1FaqDelete: (
      data: DeleteFAQRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/faq/`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags FAQs
     * @name EditFaqApiV1FaqPatch
     * @summary Edit Faq
     * @request PATCH:/api/v1/faq/
     * @secure
     */
    editFaqApiV1FaqPatch: (data: EditFAQRequest, params: RequestParams = {}) =>
      this.request<EditFAQResponse, HTTPValidationError>({
        path: `/api/v1/faq/`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags FAQs
     * @name ListFaqsApiV1FaqListGet
     * @summary List Faqs
     * @request GET:/api/v1/faq/list
     * @secure
     */
    listFaqsApiV1FaqListGet: (
      query: {
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<ListFAQResponse, HTTPValidationError>({
        path: `/api/v1/faq/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags File Storage Gateway
     * @name PutPhotoApiV1FileStoragePhotoPost
     * @summary Put Photo
     * @request POST:/api/v1/file-storage/photo
     * @secure
     */
    putPhotoApiV1FileStoragePhotoPost: (
      data: BodyPutPhotoApiV1FileStoragePhotoPost,
      params: RequestParams = {}
    ) =>
      this.request<S3PutPhotoResponse, HTTPValidationError>({
        path: `/api/v1/file-storage/photo`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags File Storage Gateway
     * @name DeleteFilesApiV1FileStorageDeleteDelete
     * @summary Delete Files
     * @request DELETE:/api/v1/file-storage/delete
     * @secure
     */
    deleteFilesApiV1FileStorageDeleteDelete: (
      data: DeleteFilesRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/file-storage/delete`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags File Storage Gateway
     * @name PutFileApiV1FileStorageFilePost
     * @summary Put File
     * @request POST:/api/v1/file-storage/file
     * @secure
     */
    putFileApiV1FileStorageFilePost: (
      data: BodyPutFileApiV1FileStorageFilePost,
      params: RequestParams = {}
    ) =>
      this.request<FileKeyResponse, ExceptionSchema | HTTPValidationError>({
        path: `/api/v1/file-storage/file`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags File Storage Gateway
     * @name PutStaticApiV1FileStorageStaticPost
     * @summary Put Static
     * @request POST:/api/v1/file-storage/static
     * @secure
     */
    putStaticApiV1FileStorageStaticPost: (
      data: BodyPutStaticApiV1FileStorageStaticPost,
      params: RequestParams = {}
    ) =>
      this.request<S3PutStaticResponse, HTTPValidationError>({
        path: `/api/v1/file-storage/static`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags File Storage Gateway
     * @name ListInuviFilesApiV1FileStorageInuviFilesGet
     * @summary List Inuvi Files
     * @request GET:/api/v1/file-storage/inuvi/files
     * @secure
     */
    listInuviFilesApiV1FileStorageInuviFilesGet: (
      query?: {
        /**
         * Limit
         * @min 1
         * @max 100
         * @default 10
         */
        limit?: number;
        /**
         * Offset
         * @min 0
         * @default 0
         */
        offset?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<FileDTO[], ExceptionSchema | HTTPValidationError>({
        path: `/api/v1/file-storage/inuvi/files`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Counters
     * @name GetDoctorsCountApiV1CounterDoctorsGet
     * @summary Get Doctors Count
     * @request GET:/api/v1/counter/doctors
     * @secure
     */
    getDoctorsCountApiV1CounterDoctorsGet: (params: RequestParams = {}) =>
      this.request<CounterResponse, ExceptionSchema>({
        path: `/api/v1/counter/doctors`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Counters
     * @name GetNutritionistsCountApiV1CounterNutritionistsGet
     * @summary Get Nutritionists Count
     * @request GET:/api/v1/counter/nutritionists
     * @secure
     */
    getNutritionistsCountApiV1CounterNutritionistsGet: (
      params: RequestParams = {}
    ) =>
      this.request<CounterResponse, ExceptionSchema>({
        path: `/api/v1/counter/nutritionists`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Counters
     * @name GetMembersNotificationsCounterApiV1CounterMemberNotificationsGet
     * @summary Get Members Notifications Counter
     * @request GET:/api/v1/counter/member-notifications
     * @secure
     */
    getMembersNotificationsCounterApiV1CounterMemberNotificationsGet: (
      params: RequestParams = {}
    ) =>
      this.request<CounterResponse, ExceptionSchema>({
        path: `/api/v1/counter/member-notifications`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Counters
     * @name GetMembersNotificationsForBsCounterApiV1CounterBsNotificationsGet
     * @summary Get Members Notifications For Bs Counter
     * @request GET:/api/v1/counter/bs-notifications
     * @secure
     */
    getMembersNotificationsForBsCounterApiV1CounterBsNotificationsGet: (
      params: RequestParams = {}
    ) =>
      this.request<CounterResponse, ExceptionSchema>({
        path: `/api/v1/counter/bs-notifications`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Counters
     * @name CountUnprocessedBiomarkerResultsApiV1CounterUnprocessedCountGet
     * @summary Count Unprocessed Biomarker Results
     * @request GET:/api/v1/counter/unprocessed-count
     * @secure
     */
    countUnprocessedBiomarkerResultsApiV1CounterUnprocessedCountGet: (
      params: RequestParams = {}
    ) =>
      this.request<CountUnprocessedBiomarkerResultsResponse, ExceptionSchema>({
        path: `/api/v1/counter/unprocessed-count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Get the total count of notes for the authenticated member
     *
     * @tags Counters
     * @name GetNotesCountApiV1CounterNotesGet
     * @summary Get notes count
     * @request GET:/api/v1/counter/notes
     * @secure
     */
    getNotesCountApiV1CounterNotesGet: (params: RequestParams = {}) =>
      this.request<GetNotesCountResponse, any>({
        path: `/api/v1/counter/notes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name GetMembersNotificationsCounterApiV1NotificationListGet
     * @summary Get Members Notifications Counter
     * @request GET:/api/v1/notification/list
     * @secure
     */
    getMembersNotificationsCounterApiV1NotificationListGet: (
      query: {
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ListMemberNotificationsResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/notification/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name ReadNotificationApiV1NotificationReadPatch
     * @summary Read Notification
     * @request PATCH:/api/v1/notification/read
     * @secure
     */
    readNotificationApiV1NotificationReadPatch: (
      data: ReadNotificationRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        ReadNotificationResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/notification/read`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Nutritionists
     * @name GetNutritionistsListApiV1NutritionistsListGet
     * @summary Get Nutritionists List
     * @request GET:/api/v1/nutritionists/list
     * @secure
     */
    getNutritionistsListApiV1NutritionistsListGet: (
      query: {
        /** Loading Strategy */
        loading_strategy?: NutritionistLoadStrategy | null;
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ListNutritionistsResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/nutritionists/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Nutritionists
     * @name GetNutritionistMembersListApiV1NutritionistsMembersGet
     * @summary Get Nutritionist Members List
     * @request GET:/api/v1/nutritionists/members
     * @secure
     */
    getNutritionistMembersListApiV1NutritionistsMembersGet: (
      query: {
        /** Loading Strategy */
        loading_strategy?: MemberLoadStrategy | null;
        /** Limit */
        limit: number;
        /** Offset */
        offset: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        ListNutritionistMembersResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/nutritionists/members`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Nutritionists
     * @name GetNutritionistApiV1NutritionistsUserIdGet
     * @summary Get Nutritionist
     * @request GET:/api/v1/nutritionists/{user_id}
     * @secure
     */
    getNutritionistApiV1NutritionistsUserIdGet: (
      userId: string,
      params: RequestParams = {}
    ) =>
      this.request<
        GetNutritionistResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/nutritionists/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Nutritionists
     * @name CreateNutritionistApiV1NutritionistsPost
     * @summary Create Nutritionist
     * @request POST:/api/v1/nutritionists/
     * @secure
     */
    createNutritionistApiV1NutritionistsPost: (
      data: CreateNutritionistRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<CreateUserResponse, HTTPValidationError>({
        path: `/api/v1/nutritionists/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Nutritionists
     * @name DeleteNutritionistApiV1NutritionistsDelete
     * @summary Delete Nutritionist
     * @request DELETE:/api/v1/nutritionists/
     * @secure
     */
    deleteNutritionistApiV1NutritionistsDelete: (
      data: DeleteNutritionistRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/nutritionists/`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Nutritionists
     * @name UpdateNutritionistApiV1NutritionistsPatch
     * @summary Update Nutritionist
     * @request PATCH:/api/v1/nutritionists/
     * @secure
     */
    updateNutritionistApiV1NutritionistsPatch: (
      data: UpdateNutritionistRequestPydantic,
      params: RequestParams = {}
    ) =>
      this.request<
        UpdateNutritionistResponse,
        ExceptionSchema | HTTPValidationError
      >({
        path: `/api/v1/nutritionists/`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Nutritionists
     * @name DeactivateNutritionistApiV1NutritionistsDeactivatePatch
     * @summary Deactivate Nutritionist
     * @request PATCH:/api/v1/nutritionists/deactivate
     * @secure
     */
    deactivateNutritionistApiV1NutritionistsDeactivatePatch: (
      data: DeactivateNutritionistRequest,
      params: RequestParams = {}
    ) =>
      this.request<DeactivateNutritionistResponse, HTTPValidationError>({
        path: `/api/v1/nutritionists/deactivate`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Nutritionists
     * @name ActivateNutritionistApiV1NutritionistsActivatePatch
     * @summary Activate Nutritionist
     * @request PATCH:/api/v1/nutritionists/activate
     * @secure
     */
    activateNutritionistApiV1NutritionistsActivatePatch: (
      data: ActivateNutritionistRequest,
      params: RequestParams = {}
    ) =>
      this.request<ActivateNutritionistResponse, HTTPValidationError>({
        path: `/api/v1/nutritionists/activate`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Recommendations
     * @name CreateRecommendationApiV1RecommendationsPost
     * @summary Create Recommendation
     * @request POST:/api/v1/recommendations/
     * @secure
     */
    createRecommendationApiV1RecommendationsPost: (
      data: CreateRecommendationRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateRecommendationResponse, HTTPValidationError>({
        path: `/api/v1/recommendations/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Recommendations
     * @name DeleteRecommendationApiV1RecommendationsDelete
     * @summary Delete Recommendation
     * @request DELETE:/api/v1/recommendations/
     * @secure
     */
    deleteRecommendationApiV1RecommendationsDelete: (
      data: DeleteRecommendationRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/recommendations/`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params
      }),

    /**
     * No description
     *
     * @tags Recommendations
     * @name UpdateRecommendationApiV1RecommendationsPatch
     * @summary Update Recommendation
     * @request PATCH:/api/v1/recommendations/
     * @secure
     */
    updateRecommendationApiV1RecommendationsPatch: (
      data: UpdateRecommendationRequest,
      params: RequestParams = {}
    ) =>
      this.request<UpdateRecommendationResponse, HTTPValidationError>({
        path: `/api/v1/recommendations/`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Recommendations
     * @name ListRecommendationsApiV1RecommendationsListGet
     * @summary List Recommendations
     * @request GET:/api/v1/recommendations/list
     * @secure
     */
    listRecommendationsApiV1RecommendationsListGet: (
      query?: {
        /** Member Id */
        member_id?: string | null;
        /** Category Id */
        category_id?: number | null;
      },
      params: RequestParams = {}
    ) =>
      this.request<ListRecommendationsResponse, HTTPValidationError>({
        path: `/api/v1/recommendations/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Recommendations
     * @name ListCategoriesApiV1RecommendationsCategoriesGet
     * @summary List Categories
     * @request GET:/api/v1/recommendations/categories
     * @secure
     */
    listCategoriesApiV1RecommendationsCategoriesGet: (
      params: RequestParams = {}
    ) =>
      this.request<ListRecommendationCategoriesResponse, any>({
        path: `/api/v1/recommendations/categories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Pharmacy Booking
     * @name CreateTuliBookingApiV1PharmacyPost
     * @summary Create Tuli Booking
     * @request POST:/api/v1/pharmacy/
     * @secure
     */
    createTuliBookingApiV1PharmacyPost: (
      data: CreateTuliBookingRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateTuliBookingResponse, HTTPValidationError>({
        path: `/api/v1/pharmacy/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Pharmacy Booking
     * @name PharmacyAvailableSlotsApiV1PharmacySlotsGet
     * @summary Pharmacy Available Slots
     * @request GET:/api/v1/pharmacy/slots
     * @secure
     */
    pharmacyAvailableSlotsApiV1PharmacySlotsGet: (
      query: {
        /** Pharmacy Id */
        pharmacy_id: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PharmacyAvailableSlotsResponse, HTTPValidationError>({
        path: `/api/v1/pharmacy/slots`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Pharmacy Booking
     * @name SearchPharmacyApiV1PharmacySearchGet
     * @summary Search Pharmacy
     * @request GET:/api/v1/pharmacy/search
     * @secure
     */
    searchPharmacyApiV1PharmacySearchGet: (
      query: {
        /** Postcode */
        postcode: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SearchPharmacyResponse, HTTPValidationError>({
        path: `/api/v1/pharmacy/search`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags Pharmacy Booking
     * @name GetTuliBookingInfoApiV1PharmacyBookingBookingIdGet
     * @summary Get Tuli Booking Info
     * @request GET:/api/v1/pharmacy/booking/{booking_id}
     * @secure
     */
    getTuliBookingInfoApiV1PharmacyBookingBookingIdGet: (
      bookingId: number,
      params: RequestParams = {}
    ) =>
      this.request<GetTuliBookingInfoResponse, HTTPValidationError>({
        path: `/api/v1/pharmacy/booking/${bookingId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags subscriptions
     * @name CreateSubscriptionApiV1SubscriptionsPost
     * @summary Create Subscription
     * @request POST:/api/v1/subscriptions/
     * @secure
     */
    createSubscriptionApiV1SubscriptionsPost: (
      data: CreateSubscriptionRequest,
      params: RequestParams = {}
    ) =>
      this.request<CreateSubscriptionResponse, void | HTTPValidationError>({
        path: `/api/v1/subscriptions/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags subscriptions
     * @name HandleWebhookApiV1SubscriptionsWebhookPost
     * @summary Handle Webhook
     * @request POST:/api/v1/subscriptions/webhook
     */
    handleWebhookApiV1SubscriptionsWebhookPost: (params: RequestParams = {}) =>
      this.request<WebhookResponse, void>({
        path: `/api/v1/subscriptions/webhook`,
        method: 'POST',
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags subscriptions
     * @name UpdateSubscriptionApiV1SubscriptionsUpdatePost
     * @summary Update Subscription
     * @request POST:/api/v1/subscriptions/update
     * @secure
     */
    updateSubscriptionApiV1SubscriptionsUpdatePost: (
      data: UpdateSubscriptionRequest,
      params: RequestParams = {}
    ) =>
      this.request<UpdateSubscriptionResponse, void | HTTPValidationError>({
        path: `/api/v1/subscriptions/update`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  };
}
